import React, { useEffect, useState, useRef, useCallback } from "react";
import axiosInstance from "../../api/axios";
import {
  Row, Col, Button, Form, Table, Modal, Badge, Spinner, Pagination,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import Header from "../../layouts/Header";
import {
  ArrowLeft, FileEarmarkSpreadsheet, Search, ChevronDown,
  Eye, Receipt, XCircle, ArrowClockwise, CloudDownload,
  CheckCircle, ExclamationTriangle, HourglassSplit, BoxArrowDown,
  X, Clock,
} from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Select from "react-select";
import OutletSelect from "../../components/OutletSelect";
import invoice from "../../assets/img/logo.jpeg"

/* ─────────────────────────────────────────────────────────
   STYLES
───────────────────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&family=Outfit:wght@300;400;500;600;700&display=swap');
  :root {
    --or-bg:#f0f2f5; --or-surface:#fff; --or-border:#e2e6ea; --or-text:#1a202c;
    --or-muted:#41505F; --or-accent:#2563eb; --or-accent-light:#eff6ff; --or-accent-dark:#1d4ed8;
    --or-success:#059669; --or-success-light:#ecfdf5; --or-warning:#d97706; --or-warning-light:#fffbeb;
    --or-danger:#dc2626; --or-danger-light:#fef2f2; --or-info:#0891b2; --or-info-light:#ecfeff;
    --or-shadow-sm:0 1px 3px rgba(0,0,0,.08),0 1px 2px rgba(0,0,0,.05);
    --or-shadow-md:0 4px 12px rgba(0,0,0,.09),0 2px 4px rgba(0,0,0,.06);
    --or-shadow-lg:0 10px 40px rgba(0,0,0,.12);
    --or-radius:10px; --or-radius-sm:8px; --or-radius-xs:6px;
  }
  .or-card{background:var(--or-surface);border-radius:var(--or-radius);box-shadow:var(--or-shadow-md);border:1px solid var(--or-border);overflow:hidden;}

  /* ── Header ── */
  .or-header{display:flex;justify-content:space-between;align-items:center;padding:18px 28px;border-bottom:1px solid var(--or-border);gap:12px;}
  .or-header-title{font-size:18px;font-weight:700;color:var(--or-text);letter-spacing:-.3px;display:flex;align-items:center;gap:10px;}
  .or-header-right{display:flex;align-items:center;gap:10px;}
  .or-back-btn{display:flex;align-items:center;gap:6px;padding:8px 16px;border-radius:var(--or-radius-xs);border:1.5px solid var(--or-border);background:var(--or-surface);color:var(--or-muted);font-size:13px;font-weight:500;cursor:pointer;transition:all .18s;text-decoration:none;}
  .or-back-btn:hover{border-color:var(--or-accent);color:var(--or-accent);background:var(--or-accent-light);}

  /* ── Filters ── */
  .or-filters{padding:20px 28px;border-bottom:1px solid var(--or-border);background:#fafbfc;}
  .or-filter-label{font-size:11.5px;font-weight:600;color:var(--or-muted);letter-spacing:.6px;margin-bottom:5px;display:block;text-transform:uppercase;}
  .or-filter-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:16px;margin-bottom:16px;align-items:end;}
  .or-filter-col{display:flex;flex-direction:column;}
  .or-filter-input{width:100%;padding:8px 10px;border:1.5px solid #e2e6ea;border-radius:6px;font-size:13.5px;outline:none;background:#fff;color:var(--or-text);transition:border-color .18s,box-shadow .18s;height:38px;}
  .or-filter-input:focus{border-color:var(--or-accent);box-shadow:0 0 0 3px rgba(37,99,235,.10);}
  .or-filter-select{width:100%;padding:8px 10px;border:1.5px solid #e2e6ea;border-radius:6px;font-size:13.5px;outline:none;background:#fff;color:var(--or-text);height:38px;cursor:pointer;transition:border-color .18s,box-shadow .18s;}
  .or-filter-select:focus{border-color:var(--or-accent);box-shadow:0 0 0 3px rgba(37,99,235,.10);}
  .or-filters .react-datepicker-wrapper{width:100%;}
  .or-filters .react-datepicker-wrapper input{width:100%;padding:8px 10px;border:1.5px solid #e2e6ea;border-radius:6px;font-size:13.5px;outline:none;background:#fff;height:38px;color:var(--or-text);transition:border-color .18s,box-shadow .18s;}
  .or-filters .react-datepicker-wrapper input:focus{border-color:var(--or-accent);box-shadow:0 0 0 3px rgba(37,99,235,.10);}

  /* Bottom row */
  .or-filter-bottom{display:flex;align-items:center;flex-wrap:wrap;gap:12px;min-height:42px;padding-top:4px;}

  .or-generate-btn{height:38px;padding:0 20px;border-radius:var(--or-radius-xs);background:var(--or-accent);border:none;color:#fff;font-size:13.5px;font-weight:600;cursor:pointer;transition:background .18s,transform .12s;display:inline-flex;align-items:center;gap:7px;white-space:nowrap;}
  .or-generate-btn:hover:not(:disabled){background:var(--or-accent-dark);transform:translateY(-1px);}
  .or-generate-btn:disabled{opacity:.55;cursor:not-allowed;}

  /* KPI */
  .or-kpi-strip{display:grid;gap:0;border-radius:var(--or-radius);border:1px solid var(--or-border);overflow:hidden;box-shadow:var(--or-shadow-sm);margin:20px 28px 0;}
  .or-kpi-cell{padding:16px 18px;border-right:1px solid var(--or-border);text-align:center;background:var(--or-surface);transition:background .15s;}
  .or-kpi-cell:last-child{border-right:none;}.or-kpi-cell:hover{background:#fafbfc;}
  .or-kpi-label{font-size:10.5px;font-weight:600;color:var(--or-muted);text-transform:uppercase;letter-spacing:.6px;margin-bottom:6px;}
  .or-kpi-value{font-size:17px;font-weight:700;letter-spacing:-.5px;}
  .or-kpi-value.blue{color:var(--or-accent);}.or-kpi-value.green{color:var(--or-success);}
  .or-kpi-value.amber{color:var(--or-warning);}.or-kpi-value.red{color:var(--or-danger);}
  .or-kpi-value.ink{color:var(--or-text);}.or-kpi-value.teal{color:var(--or-info);}
  .or-kpi-value.purple{color:#534AB7;}
.or-kpi-value.coral{color:#993C1D;}

    .or-kpi-sub-row{display:flex;gap:0;margin-top:8px;padding-top:8px;border-top:1px solid var(--or-border);}
  .or-kpi-sub-item{flex:1;text-align:center;}
  .or-kpi-sub-item:first-child{border-right:1px solid var(--or-border);}
  .or-kpi-sub-label{font-size:9.5px;font-weight:600;color:var(--or-muted);text-transform:uppercase;letter-spacing:.6px;margin-bottom:3px;}
  .or-kpi-sub-value{font-size:13px;font-weight:700;}

  /* Table */
  .or-table-wrap{overflow-x:auto;margin:0 28px 20px;border-radius:var(--or-radius-sm);border:1px solid var(--or-border);box-shadow:var(--or-shadow-sm);}
  .or-table{width:100%;border-collapse:collapse;font-size:13px;}
  .or-table thead th{padding:11px 14px;background:#f8fafc;border-bottom:1px solid var(--or-border);font-size:11px;font-weight:700;color:var(--or-muted);text-transform:uppercase;letter-spacing:.6px;white-space:nowrap;}
  .or-table tbody tr{border-bottom:1px solid #f0f2f5;transition:background .12s;}
  .or-table tbody tr:last-child{border-bottom:none;}.or-table tbody tr:hover{background:#f8fafc;}
  .or-table td{padding:11px 14px;vertical-align:middle;color:var(--or-text);}
  .or-table .row-clickable{cursor:pointer;}
  .or-orderno{font-size:12.5px;font-weight:500;color:var(--or-text);background:#f0f2f5;padding:2px 7px;border-radius:4px;white-space:nowrap;}

  /* Badges */
  .or-badge{display:inline-flex;align-items:center;gap:4px;padding:3px 9px;border-radius:20px;font-size:11px;font-weight:700;letter-spacing:.2px;white-space:nowrap;}
  .or-badge-dot{width:5px;height:5px;border-radius:50%;}
  .or-badge.completed{background:var(--or-success-light);color:var(--or-success);}
  .or-badge.delivered{background:var(--or-accent-light);color:var(--or-accent);}
  .or-badge.confirmed{background:#f3f4f6;color:#374151;}
  .or-badge.ready{background:var(--or-warning-light);color:var(--or-warning);}
  .or-badge.cancelled{background:var(--or-danger-light);color:var(--or-danger);}
  .or-badge.default{background:#f3f4f6;color:#374151;}
  .or-arrival{display:inline-flex;align-items:center;gap:4px;padding:3px 9px;border-radius:20px;font-size:11px;font-weight:600;white-space:nowrap;}
  .or-arrival.delayed{background:var(--or-danger-light);color:var(--or-danger);}
  .or-arrival.early{background:var(--or-success-light);color:var(--or-success);}
  .or-arrival.ontime{background:var(--or-accent-light);color:var(--or-accent);}
  .or-amount{font-size:12.5px;font-weight:500;white-space:nowrap;}
  .or-amount.green{color:var(--or-success);}.or-amount.amber{color:var(--or-warning);}
  .or-amount.red{color:var(--or-danger);}.or-amount.blue{color:var(--or-accent);font-weight:700;}

  /* Dropdown */
  .or-action-btn{padding:5px 12px;border-radius:var(--or-radius-xs);border:1.5px solid var(--or-border);background:var(--or-surface);font-size:12px;font-weight:500;color:var(--or-muted);cursor:pointer;display:inline-flex;align-items:center;gap:5px;transition:all .15s;}
  .or-action-btn:hover{border-color:var(--or-accent);color:var(--or-accent);background:var(--or-accent-light);}
  .or-dropdown{position:relative;}
  .or-dropdown-menu{position:absolute;right:0;top:calc(100% + 6px);background:var(--or-surface);border:1.5px solid var(--or-border);border-radius:var(--or-radius-sm);box-shadow:var(--or-shadow-lg);z-index:100;min-width:165px;overflow:hidden;animation:or-drop-in .14s ease;}
  @keyframes or-drop-in{from{opacity:0;transform:translateY(-6px);}to{opacity:1;transform:translateY(0);}}
  .or-dropdown-item{display:flex;align-items:center;gap:9px;padding:9px 14px;font-size:13px;font-weight:500;color:var(--or-text);cursor:pointer;transition:background .12s;border:none;background:none;width:100%;text-align:left;}
  .or-dropdown-item:hover{background:#f8fafc;}.or-dropdown-item.danger{color:var(--or-danger);}
  .or-dropdown-item.danger:hover{background:var(--or-danger-light);}

  /* Toolbar */
  .or-toolbar{display:flex;justify-content:space-between;align-items:center;padding:16px 28px;gap:12px;flex-wrap:wrap;border-bottom:1px solid var(--or-border);}
  .or-toolbar-left{display:flex;align-items:center;gap:8px;flex:1;}
  .or-toolbar-right{display:flex;align-items:center;gap:8px;}
  .or-toolbar-btn{height:38px;padding:0 14px;border-radius:var(--or-radius-xs);border:1.5px solid var(--or-border);background:var(--or-surface);font-size:12.5px;font-weight:500;color:var(--or-muted);cursor:pointer;display:inline-flex;align-items:center;gap:6px;transition:all .18s;white-space:nowrap;}
  .or-toolbar-btn:hover:not(:disabled){border-color:var(--or-accent);color:var(--or-accent);background:var(--or-accent-light);}
  .or-toolbar-btn:disabled{opacity:.5;cursor:not-allowed;}
  .or-toolbar-btn.green-btn{border-color:var(--or-success);color:var(--or-success);background:var(--or-success-light);}
  .or-toolbar-btn.green-btn:hover:not(:disabled){background:var(--or-success);color:#fff;}
  .or-search-wrap{position:relative;flex:1;max-width:380px;}
  .or-search-wrap .search-icon{position:absolute;left:12px;top:50%;transform:translateY(-50%);color:var(--or-muted);pointer-events:none;font-size:14px;}
  .or-search-input{width:100%;padding:9px 12px 9px 36px;border:1.5px solid var(--or-border);border-radius:var(--or-radius-xs);font-size:13.5px;background:var(--or-surface);color:var(--or-text);transition:border-color .18s,box-shadow .18s;outline:none;height:38px;}
  .or-search-input:focus{border-color:var(--or-accent);box-shadow:0 0 0 3px rgba(37,99,235,.10);}

  /* Pagination */
  .or-pagination{display:flex;justify-content:space-between;align-items:center;padding:14px 28px 20px;flex-wrap:wrap;gap:12px;}
  .or-page-info{font-size:12.5px;color:var(--or-muted);}
  .or-per-page{display:flex;align-items:center;gap:8px;font-size:12.5px;color:var(--or-muted);}
  .or-per-page select{padding:5px 10px;border:1.5px solid var(--or-border);border-radius:var(--or-radius-xs);font-size:12.5px;background:var(--or-surface);color:var(--or-text);cursor:pointer;outline:none;}

  /* Empty / Loading */
  .or-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:72px 24px;color:var(--or-muted);text-align:center;}
  .or-empty-icon{font-size:44px;margin-bottom:14px;opacity:.4;}
  .or-empty-title{font-size:16px;font-weight:600;color:#374151;margin-bottom:6px;}
  .or-empty-sub{font-size:13px;color:var(--or-muted);max-width:320px;}
  .or-loading{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:60px;gap:14px;color:var(--or-muted);}

  /* Multi-outlet notice */
  .or-multi-notice{margin:20px 28px 0;padding:14px 18px;border-radius:var(--or-radius-sm);background:#fffbeb;border:1.5px solid #fde68a;display:flex;align-items:flex-start;gap:12px;}
  .or-multi-notice-text{font-size:13px;color:#92400e;line-height:1.6;}
  .or-multi-notice-text strong{color:#78350f;}

  /* Animations */
  .or-spin{animation:or-spin .9s linear infinite;display:inline-block;}
  @keyframes or-spin{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}
  .or-pulse{animation:or-pulse 1.5s ease-in-out infinite;}
  @keyframes or-pulse{0%,100%{opacity:1;}50%{opacity:.5;}}

  /* Modal */
  .or-modal-header{border-bottom:1px solid var(--or-border) !important;padding:18px 24px !important;}
  .or-modal-title{font-size:16px;font-weight:700;}
  .or-modal-body{padding:20px 24px !important;}
  .or-modal-detail-label{font-size:10.5px;font-weight:700;color:var(--or-muted);text-transform:uppercase;letter-spacing:.7px;margin-bottom:4px;}
  .or-modal-detail-val{font-size:14px;font-weight:500;color:var(--or-text);}
  .or-detail-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-bottom:20px;}
  .or-detail-cell{padding:12px 14px;background:#f8fafc;border-radius:var(--or-radius-sm);border:1px solid var(--or-border);}

  /* ═══ Downloads button in header ═══ */
  .or-dm-fab{
    height:38px; border-radius:var(--or-radius-xs); padding:0 16px;
    background:#fff; border:1.5px solid var(--or-border);
    display:inline-flex; align-items:center; justify-content:center;
    cursor:pointer; transition:all .18s;
    color:var(--or-muted); font-size:13px; font-weight:600; gap:7px;
    white-space:nowrap; box-shadow:var(--or-shadow-sm);
  }
  .or-dm-fab:hover{border-color:var(--or-accent);color:var(--or-accent);background:var(--or-accent-light);}
  .or-dm-fab.has-active{border-color:var(--or-accent);color:var(--or-accent);background:var(--or-accent-light);}
  .or-dm-badge{
    background:#dc2626; color:#fff;
    width:18px; height:18px; border-radius:50%;
    margin-left:2px;
    font-size:10px; font-weight:700;
    display:inline-flex; align-items:center; justify-content:center;
  }

  /* ═══ FLOATING DOWNLOAD MANAGER PANEL ═══ */
  .or-dm-panel{
    position:fixed; top:72px; right:24px; z-index:1049;
    width:580px; max-height:700px;
    background:var(--or-surface);
    border-radius:14px;
    border:1.5px solid var(--or-border);
    box-shadow:0 20px 60px rgba(0,0,0,.15),0 4px 16px rgba(0,0,0,.08);
    display:flex; flex-direction:column;
    overflow:hidden;
    animation:or-dm-in .2s ease;
  }
  @keyframes or-dm-in{from{opacity:0;transform:translateY(-8px) scale(.97);}to{opacity:1;transform:translateY(0) scale(1);}}

  /* DM Header */
  .or-dm-header{
    display:flex; align-items:flex-start; justify-content:space-between;
    padding:20px 22px 18px;
    background:linear-gradient(135deg,#0f172a 0%,#1e3a8a 60%,#1d4ed8 100%);
    color:#fff; flex-shrink:0;
  }
  .or-dm-header-left{flex:1;}
  .or-dm-header-title{display:flex;align-items:center;gap:9px;font-size:15px;font-weight:700;letter-spacing:-.2px;}
  .or-dm-header-sub{font-size:11.5px;opacity:.6;margin-top:3px;}
  .or-dm-stats{display:flex;gap:10px;margin-top:14px;}
  .or-dm-stat{background:rgba(255,255,255,.1);border-radius:8px;padding:9px 16px;text-align:center;border:1px solid rgba(255,255,255,.12);min-width:70px;}
  .or-dm-stat-val{font-size:20px;font-weight:700;color:#fff;line-height:1;}
  .or-dm-stat-lbl{font-size:10px;opacity:.65;margin-top:4px;text-transform:uppercase;letter-spacing:.6px;}
  .or-dm-header-actions{display:flex;align-items:center;gap:6px;flex-shrink:0;padding-top:2px;}
  .or-dm-icon-btn{width:30px;height:30px;border-radius:7px;border:none;background:rgba(255,255,255,.12);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .15s;}
  .or-dm-icon-btn:hover{background:rgba(255,255,255,.25);}

  /* DM Body */
  .or-dm-body{overflow-y:auto;flex:1;padding:14px 16px;display:flex;flex-direction:column;gap:10px;background:#f8fafc;}
  .or-dm-body::-webkit-scrollbar{width:5px;}
  .or-dm-body::-webkit-scrollbar-thumb{background:#d1d5db;border-radius:4px;}

  /* Job card */
  .or-dm-job{display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:10px;border:1px solid var(--or-border);background:#fff;transition:box-shadow .15s,border-color .15s;}
  .or-dm-job:hover{box-shadow:var(--or-shadow-md);border-color:#cbd5e1;}
  .or-dm-job-icon{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:17px;}
  .or-dm-job-icon.pending{background:#fef3c7;color:#d97706;}
  .or-dm-job-icon.processing{background:var(--or-accent-light);color:var(--or-accent);}
  .or-dm-job-icon.completed{background:var(--or-success-light);color:var(--or-success);}
  .or-dm-job-icon.failed{background:var(--or-danger-light);color:var(--or-danger);}
  .or-dm-job-info{flex:1;min-width:0;}
  .or-dm-job-name{font-size:13px;font-weight:600;color:var(--or-text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .or-dm-job-meta{font-size:11.5px;color:#64748b;margin-top:3px;display:flex;align-items:center;gap:6px;flex-wrap:wrap;}

  /* Progress bar */
  .or-pb-wrap{height:4px;background:#e2e8f0;border-radius:3px;margin-top:7px;overflow:hidden;}
  .or-pb{height:100%;border-radius:3px;transition:width .5s ease;}
  .or-pb.pending{background:#fcd34d;width:8%;}
  .or-pb.processing{background:var(--or-accent);width:60%;animation:or-pb-shimmer 1.5s ease-in-out infinite;}
  .or-pb.completed{background:var(--or-success);width:100%;}
  .or-pb.failed{background:var(--or-danger);width:100%;}
  @keyframes or-pb-shimmer{0%,100%{opacity:1;}50%{opacity:.55;}}

  /* Status pill */
  .or-status-pill{font-size:10.5px;font-weight:700;padding:3px 10px;border-radius:20px;white-space:nowrap;flex-shrink:0;}
  .or-status-pill.pending{background:#fef3c7;color:#d97706;}
  .or-status-pill.processing{background:var(--or-accent-light);color:var(--or-accent);}
  .or-status-pill.completed{background:var(--or-success-light);color:var(--or-success);}
  .or-status-pill.failed{background:var(--or-danger-light);color:var(--or-danger);}

  /* Download button */
  .or-dl-btn{height:32px;padding:0 14px;border-radius:var(--or-radius-xs);border:1.5px solid #a7f3d0;background:var(--or-success-light);color:var(--or-success);font-size:12px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:5px;transition:all .15s;white-space:nowrap;flex-shrink:0;}
  .or-dl-btn:hover{background:var(--or-success);color:#fff;border-color:var(--or-success);}

  /* Delete/Cancel job button */
.or-del-btn{
  width:30px; height:30px; border-radius:var(--or-radius-xs);
  border:1.5px solid #fecaca; background:var(--or-danger-light);
  color:var(--or-danger); cursor:pointer;
  display:inline-flex; align-items:center; justify-content:center;
  transition:all .15s; flex-shrink:0;
}
.or-del-btn:hover:not(:disabled){background:var(--or-danger);color:#fff;border-color:var(--or-danger);}
.or-del-btn:disabled{opacity:.5;cursor:not-allowed;}

/* Regenerate button */
.or-regen-btn{
  width:30px; height:30px; border-radius:var(--or-radius-xs);
  border:1.5px solid #bfdbfe; background:var(--or-accent-light);
  color:var(--or-accent); cursor:pointer;
  display:inline-flex; align-items:center; justify-content:center;
  transition:all .15s; flex-shrink:0;
}
.or-regen-btn:hover:not(:disabled){background:var(--or-accent);color:#fff;border-color:var(--or-accent);}
.or-regen-btn:disabled{opacity:.5;cursor:not-allowed;}

  /* DM Footer */
  .or-dm-footer{padding:12px 18px;border-top:1px solid var(--or-border);flex-shrink:0;display:flex;align-items:center;justify-content:space-between;background:#fff;}
  .or-dm-footer-info{font-size:12px;color:var(--or-muted);display:flex;align-items:center;gap:5px;}
  .or-dm-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:48px 20px;color:var(--or-muted);text-align:center;gap:10px;}

  /* ── Responsive ── */
  @media(max-width:1200px){
    .or-filter-grid{grid-template-columns:repeat(3,1fr);}
  }
  @media(max-width:768px){
    .or-filter-grid{grid-template-columns:repeat(2,1fr);}
    .or-kpi-strip{grid-template-columns:repeat(3,1fr);}
    .or-detail-grid{grid-template-columns:repeat(2,1fr);}
    .or-dm-panel{width:calc(100vw - 32px);left:16px;right:16px;top:72px;}
  }
  @media(max-width:480px){
    .or-filter-grid{grid-template-columns:1fr;}
    .or-kpi-strip{grid-template-columns:repeat(2,1fr);}
    .or-detail-grid{grid-template-columns:1fr;}
    .or-header-right{gap:6px;}
    .or-back-btn span{display:none;}
  }
`;

/* ─────────────────────────────────────────────────────────
   COMPONENT
───────────────────────────────────────────────────────── */
const OrdersReport = () => {
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = useState(currentSkin);
  const navigate = useNavigate();
  const [isClicked, setIsClicked] = useState(false);

  const { userId, access, email } = useSelector((s) => s.login);
  const [reportAccess, setReportAccess] = useState([]);
  useEffect(() => {
    if (Array.isArray(access))
      setReportAccess(access.filter((p) => p?.startsWith("OrdersReport:")));
  }, [access]);

  const accessToken = localStorage.getItem("authToken");

  /* ── Filters ── */
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [orderType, setOrderType] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [searchText, setSearchText] = useState("");
  const [currentDate, setCurrentDate] = useState(null);

  /* ── Single-outlet table state ── */
  const [orders, setOrders] = useState([]);
  const [summaryData, setSummaryData] = useState(null);
  const [paginationData, setPaginationData] = useState({ currentPage: 1, totalPages: 1 });
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(25);

  /* ── UI ── */
  const [loading, setLoading] = useState(false);
  const [subBtnLoading, setSubBtnLoading] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [isMultiOutlet, setIsMultiOutlet] = useState(false);
  const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);
  const [singleOrderDetailsLoading, setSingleOrderDetailsLoading] = useState(false);

  /* ── Download manager ── */
  // ── Download Manager date filters ──
  const [dmStartDate, setDmStartDate] = useState(() => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  });
  const [dmEndDate, setDmEndDate] = useState(() => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  });
  const [dmOpen, setDmOpen] = useState(false);
  const [downloadJobs, setDownloadJobs] = useState([]);
  const [pollingActive, setPollingActive] = useState(false);
  const [jobsLoading, setJobsLoading] = useState(false);
  const pollingRef = useRef(null);
  const dmPanelRef = useRef(null);

  /* ── Cancel order ── */
  const [cancelBtnLoading, setCancelBtnLoading] = useState(false);
  const [openCancelOrderModal, setOpenCancelOrderModal] = useState(false);
  const [cancelOrderData, setCancelOrderData] = useState({});
  const [refundType, setRefundType] = useState("");
  const [isStockRefund, setIsStockRefund] = useState(false);
  const [reason, setReason] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [usersList, setUsersList] = useState([]);
  const [selectedAdminUser, setSelectedAdminUser] = useState("");

  /* ── View details ── */
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [viewDetailsModal, setViewDetailsModal] = useState(false);

  /* ── Dropdown ── */
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const dropdownRef = useRef(null);

  const [deletingJobId, setDeletingJobId] = useState(null);
  const [regeneratingJobId, setRegeneratingJobId] = useState(null);

  /* ─── Init ─── */
  useEffect(() => {
    const now = new Date();
    const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    setCurrentDate(d);
    getAdminUsersList();
    fetchDownloadStatus(true);
  }, []);

  useEffect(() => {
    if (currentDate) {
      setStartDate(currentDate);
      setEndDate(currentDate);
    }
  }, [currentDate]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setOpenDropdownId(null);
      if (dmPanelRef.current && !dmPanelRef.current.contains(e.target)) {
        const fab = document.getElementById("or-dm-fab");
        if (fab && !fab.contains(e.target)) setDmOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (clicked && !isMultiOutlet && startDate && endDate) {
      fetchSingleOutletOrders(1);
    }
  }, [recordsPerPage]);

  useEffect(() => () => stopPolling(), []);

  /* ─── Format date helper ─── */
  const fmtDate = (d) => {
    if (!d) return undefined;
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  };

  const handleDeleteReportRequest = async (jobId) => {
    try {
      setDeletingJobId(jobId);
      const headers = { Authorization: `Bearer ${accessToken}` };
      await axiosInstance.delete("report/delete-report-request", {
        headers,
        data: { requestId: jobId },
      });
      toast.success("Request cancelled successfully.", {
        position: "top-right", autoClose: 2000, theme: "light",
      });
      fetchDownloadStatus(true);
    } catch (error) {
      toast.error("Failed to cancel request.", {
        position: "top-right", autoClose: 3000, theme: "light",
      });
    } finally {
      setDeletingJobId(null);
    }
  };

  const handleRegenerateReport = async (jobId) => {
    try {
      setRegeneratingJobId(jobId);
      const headers = { Authorization: `Bearer ${accessToken}` };
      await axiosInstance.delete("report/delete-report-storage-path", {
        headers,
        data: { requestId: jobId },
      });
      toast.success("Report regeneration triggered! Please wait…", {
        position: "top-right", autoClose: 2500, theme: "light",
      });
      startPolling(); // start polling since status will go back to processing
      fetchDownloadStatus(true);
    } catch (error) {
      toast.error("Failed to trigger regeneration.", {
        position: "top-right", autoClose: 3000, theme: "light",
      });
    } finally {
      setRegeneratingJobId(null);
    }
  };


  /* ═══════════════════════════════════════
     SINGLE OUTLET — fetch orders
  ═══════════════════════════════════════ */
  const fetchSingleOutletOrders = async (page = 1) => {
    try {
      setLoading(true);
      const headers = { Authorization: `Bearer ${accessToken}` };
      const outletIds = selectedOutlet?.map((o) => o.value) || [];
      const params = {};
      if (startDate) params.startDate = fmtDate(startDate);
      if (endDate) params.endDate = fmtDate(endDate);
      params.page = String(page);
      params.limit = String(recordsPerPage);
      if (searchText) params.search = searchText;
      if (orderType) params.orderType = orderType;
      if (orderStatus) params.orderStatus = orderStatus;

      const res = await axiosInstance({
        method: "POST",
        url: "order/getOrdersForAdmin/new",
        params,
        data: { outletIds },
        headers: { ...headers, "Content-Type": "application/json" },
      });

      const data = res?.data?.data;
      if (data?.title === "Success") {
        const sorted = (data.orders || []).sort((a, b) => {
          const diff = new Date(b.createdAt) - new Date(a.createdAt);
          if (diff !== 0) return diff;
          const sa = `${a.order_sequence || ""}${a.order_no || ""}`;
          const sb = `${b.order_sequence || ""}${b.order_no || ""}`;
          return sb.localeCompare(sa, undefined, { numeric: true });
        });
        setOrders(sorted);
        setSummaryData(data.totalSummaryData || null);
        setPaginationData(data.paginationData || { currentPage: 1, totalPages: 1 });
        setCurrentPage(data.paginationData?.currentPage || 1);
        toast.success("Report fetched successfully", {
          position: "top-right", autoClose: 2000, theme: "light",
        });
      } else {
        setOrders([]);
        setPaginationData({ currentPage: 1, totalPages: 1 });
        toast.info("No records found.", {
          position: "top-right", autoClose: 3000, theme: "light",
        });
      }
    } catch (error) {
      setOrders([]);
      const s = error?.response?.status;
      const msg =
        s === 406
          ? error.response.data?.error?.message || error.response.data?.error
          : s === 412
            ? error.response.data?.data?.message
            : s === 500
              ? error.response.data?.error
              : "Something went wrong.";
      toast.error(msg, { position: "top-right", autoClose: 3000, theme: "light" });
    } finally {
      setLoading(false);
      setSubBtnLoading(false);
    }
  };

  /* ═══════════════════════════════════════
     SINGLE OUTLET — download Excel directly
  ═══════════════════════════════════════ */
  const handleSingleOutletDownload = async () => {
    try {
      setDownloadBtnLoading(true);
      const headers = { Authorization: `Bearer ${accessToken}` };
      const outletIds = selectedOutlet?.map((o) => o.value) || [];
      const params = {};
      if (startDate) params.startDate = fmtDate(startDate);
      if (endDate) params.endDate = fmtDate(endDate);
      if (orderType) params.orderType = orderType;
      if (orderStatus) params.orderStatus = orderStatus;
      if (searchText) params.search = searchText;
      params.isDownload = "true";

      const response = await axiosInstance({
        method: "POST",
        url: "order/getOrdersForAdmin/new",
        params,
        data: { outletIds },
        headers: { ...headers, "Content-Type": "application/json" },
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Order_Report_${selectedOutlet?.[0]?.label || "Outlet"}_${fmtDate(startDate)}_to_${fmtDate(endDate)}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);

      toast.success("Excel downloaded successfully!", {
        position: "top-right", autoClose: 3000, theme: "light",
      });
    } catch (error) {
      const s = error?.response?.status;
      const msg =
        s === 406
          ? error.response.data?.error?.message || error.response.data?.error
          : "Failed to download Excel.";
      toast.error(msg, { position: "top-right", autoClose: 3000, theme: "light" });
    } finally {
      setDownloadBtnLoading(false);
    }
  };

  /* ═══════════════════════════════════════
     MULTI OUTLET — trigger backend job
  ═══════════════════════════════════════ */
  const triggerMultiOutletDownload = async () => {
    try {
      setDownloadBtnLoading(true);
      const headers = { Authorization: `Bearer ${accessToken}` };
      const outletIds = selectedOutlet?.map((o) => o.value) || [];
      const params = {};
      if (startDate) params.startDate = fmtDate(startDate);
      if (endDate) params.endDate = fmtDate(endDate);
      if (orderType) params.orderType = orderType;
      if (orderStatus) params.orderStatus = orderStatus;
      params.isDownload = "true";

      await axiosInstance({
        method: "POST",
        url: "order/getOrdersForAdmin/new",
        params,
        data: { outletIds },
        headers: { ...headers, "Content-Type": "application/json" },
      });

      toast.success("Download job queued!", {
        position: "top-right", autoClose: 2500, theme: "light",
      });
      setDmOpen(true);
      startPolling();
    } catch (error) {
      const s = error?.response?.status;
      const msg =
        s === 406
          ? error.response.data?.error?.message || error.response.data?.error
          : "Failed to queue download job.";
      toast.error(msg, { position: "top-right", autoClose: 3000, theme: "light" });
    } finally {
      setDownloadBtnLoading(false);
      setSubBtnLoading(false);
    }
  };

  const handleDmDateChange = (type, date) => {
    if (type === "start") {
      // Enforce 30-day max: if new start pushes end beyond 30 days, clamp end
      setDmStartDate(date);
      if (date && dmEndDate) {
        const diffDays = (dmEndDate.getTime() - date.getTime()) / (1000 * 60 * 60 * 24);
        if (diffDays > 30) {
          const clampedEnd = new Date(date);
          clampedEnd.setDate(clampedEnd.getDate() + 30);
          setDmEndDate(clampedEnd);
          fetchDownloadStatus(false, date, clampedEnd);
          return;
        }
      }
      fetchDownloadStatus(false, date, dmEndDate);
    } else {
      setDmEndDate(date);
      fetchDownloadStatus(false, dmStartDate, date);
    }
  };

  /* ═══════════════════════════════════════
     POLLING
  ═══════════════════════════════════════ */
  const fetchDownloadStatus = useCallback(
    async (silent = false, overrideStart, overrideEnd) => {
      try {
        if (!silent) setJobsLoading(true);
        const headers = { Authorization: `Bearer ${accessToken}` };

        // Use overrides (for manual date changes) or current state
        const today = new Date();
        const todayStr = fmtDate(today);
        const sDate = overrideStart !== undefined ? overrideStart : dmStartDate;
        const eDate = overrideEnd !== undefined ? overrideEnd : dmEndDate;
        const startParam = sDate ? fmtDate(sDate) : todayStr;
        const endParam = eDate ? fmtDate(eDate) : todayStr;

        const res = await axiosInstance.get("report/get-report-status/ORDER_REPORT", {
          headers,
          params: { startDate: startParam, endDate: endParam },
        });
        const jobs =
          res?.data?.data?.reportRequests || res?.data?.reportRequests || [];
        const jobArr = Array.isArray(jobs) ? jobs : [];
        const sorted = [...jobArr].sort((a, b) => {
          const termA = a.status === "COMPLETED" || a.status === "FAILED";
          const termB = b.status === "COMPLETED" || b.status === "FAILED";
          if (termA !== termB) return termA ? 1 : -1;
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
        setDownloadJobs(sorted);
        const allDone = jobArr.every(
          (j) => j.status === "COMPLETED" || j.status === "FAILED"
        );
        if (allDone && jobArr.length > 0) stopPolling();
      } catch (e) {
        console.error("Poll error:", e);
      } finally {
        if (!silent) setJobsLoading(false);
      }
    },
    [accessToken, dmStartDate, dmEndDate]
  );

  const startPolling = useCallback(() => {
    setPollingActive(true);
    fetchDownloadStatus(true);
    if (pollingRef.current) clearInterval(pollingRef.current);
    pollingRef.current = setInterval(() => fetchDownloadStatus(true), 5000);
  }, [fetchDownloadStatus]);

  const stopPolling = useCallback(() => {
    setPollingActive(false);
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }
  }, []);

  /* ═══════════════════════════════════════
     SUBMIT
  ═══════════════════════════════════════ */
  // const handleSubmit = async () => {
  //   if (!selectedOutlet || selectedOutlet.length === 0 || !startDate || !endDate)
  //     return;
  //   setSubBtnLoading(true);
  //   setClicked(true);
  //   const multi = selectedOutlet.length > 1;
  //   setIsMultiOutlet(multi);
  //   setOrders([]);
  //   setSummaryData(null);
  //   if (multi) {
  //     await triggerMultiOutletDownload();
  //   } else {
  //     await fetchSingleOutletOrders(1);
  //   }
  // };

  // AFTER
  const isLongRange = (start, end) => {
    if (!start || !end) return false;
    const diffDays = (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);
    return diffDays > 90;
  };

  const handleSubmit = async () => {
    if (!selectedOutlet || selectedOutlet.length === 0 || !startDate || !endDate)
      return;
    setSubBtnLoading(true);
    setClicked(true);
    const multi = selectedOutlet.length > 1 || isLongRange(startDate, endDate);
    setIsMultiOutlet(multi);
    setOrders([]);
    setSummaryData(null);
    if (multi) {
      await triggerMultiOutletDownload();
    } else {
      await fetchSingleOutletOrders(1);
    }
  };

  const handlePageChange = (page) => {
    if (page < 1 || page > paginationData.totalPages) return;
    setCurrentPage(page);
    fetchSingleOutletOrders(page);
  };

  /* ─── Admin users ─── */
  const getAdminUsersList = async () => {
    try {
      const headers = { Authorization: `Bearer ${accessToken}` };
      const res = await axiosInstance.get("admin-user-management", { headers });
      if (res?.data?.status === true) {
        setUsersList(
          res.data.data.dbResponse.map((item, i) => ({
            ...item,
            serialNumber: i + 1,
          }))
        );
      }
    } catch (e) {
      console.log(e);
    }
  };
  const adminUserOptions = usersList.map((u) => ({ value: u._id, label: u.name }));

  /* ─── Cancel ─── */
  const handleOpenCancelOrderModal = (orderData) => {
    setOpenCancelOrderModal(true);
    setCancelOrderData(orderData);
    setSelectedOrderId(orderData?._id);
  };
  const handleCloseCancelOrderModal = () => {
    setOpenCancelOrderModal(false);
    setRefundType("");
    setIsStockRefund(false);
    setSelectedOrderId("");
    setReason("");
    setSelectedAdminUser("");
  };
  const handleCancelOrder = async (e) => {
    e.preventDefault();
    setCancelBtnLoading(true);
    try {
      const headers = { Authorization: `Bearer ${accessToken}` };
      const url = cancelOrderData?.subscriptionId
        ? "order/cancelOrderAdmin"
        : "order/cancel/admin/new";
      const res = await axiosInstance.put(
        url,
        { refundType, reason, isStockRefund, _id: selectedOrderId, approval: selectedAdminUser, userId },
        { headers }
      );
      toast.success(res?.data?.data?.message, {
        position: "top-right", autoClose: 3000, theme: "colored",
      });
      handleCloseCancelOrderModal();
      fetchSingleOutletOrders(currentPage);
    } catch (error) {
      const s = error.response?.status;
      const msg =
        s === 406
          ? error.response.data?.error?.message || error.response.data?.error
          : s === 403
            ? error.response.data?.data?.message || error.response.data?.error
            : s === 412
              ? error.response.data?.data?.message
              : s === 500
                ? error.response.data?.error
                : "Something went wrong.";
      toast.error(msg, { position: "top-right", autoClose: 3000, theme: "light" });
    } finally {
      setCancelBtnLoading(false);
    }
  };

  /* ─── Helpers ─── */
  const fmtViewDate = (d) =>
    new Date(d).toLocaleDateString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
    });
  const fmtViewTime = (d) =>
    new Date(d).toLocaleTimeString("en-US", {
      hour: "2-digit", minute: "2-digit", hour12: true,
    });
  const getItemTotal = (item) =>
    (item.rate + (item?.addons?.reduce((s, a) => s + a.price, 0) || 0)) * item.quantity;

  const getStatusClass = (s) =>
    ({ COMPLETED: "completed", DELIVERED: "delivered", CONFIRMED: "confirmed", "READY-TO-PICK": "ready", CANCELLED: "cancelled" }[s] || "default");

  const getStatusBadgeColor = (s) =>
    ({ COMPLETED: "success", DELIVERED: "primary", CONFIRMED: "secondary", "READY-TO-PICK": "warning", CANCELLED: "danger" }[s] || "dark");

  const getOrderUserBadge = (o) => {
    console.log("o :", o);

    if (o?.subscriptionId)
      return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 8px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: "#f0fdf4", color: "#15803d", border: "1px solid #bbf7d0", marginTop: 3 }}>
          Subscription
        </span>
      );
    if (o?.kioskUser)
      return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 8px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: "#eff6ff", color: "#1d4ed8", border: "1px solid #bfdbfe", marginTop: 3 }}>
          Kiosk
        </span>
      );
    if (o.paymentMode === "COMPLIMENTARY" || o.grandTotal === 0)
      return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 8px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: "#fdf4ff", color: "#7e22ce", border: "1px solid #e9d5ff", marginTop: 3 }}>
          Complimentary
        </span>
      );
    if (o?.outletUser && o.source === "POS" && o.paymentMode !== "COMPLIMENTARY")
      return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 8px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: "#fdf4ff", color: "#ce2295", border: "1px solid #e9d5ff", marginTop: 3 }}>
          POS
        </span>
      );
    return null;
  };

  /* ─── Job status helpers ─── */
  const getJobCls = (s) => {
    const v = s?.toLowerCase();

    if (v === "completed") return "completed";
    if (v === "failed") return "failed";
    if (v === "no_data") return "no_data";
    if (v === "processing" || v === "in-progress") return "processing";

    return "pending";
  };
  const getJobIcon = (s) => {
    const c = getJobCls(s);
    if (c === "completed") return <CheckCircle size={16} />;
    if (c === "failed") return <ExclamationTriangle size={16} />;
    if (c === "processing")
      return (
        <span className="or-spin">
          <ArrowClockwise size={16} />
        </span>
      );
    return <HourglassSplit size={16} />;
  };
  const getJobLabel = (s) =>
  ({
    completed: "Completed",
    failed: "Failed",
    no_data: "No data found for selected filters",
    processing: "Processing...",
    pending: "Queued",
  }[getJobCls(s)] || "Queued");

  const pendingCount = downloadJobs.filter(
    (j) => getJobCls(j.status) === "pending" || getJobCls(j.status) === "processing"
  ).length;
  const completedCount = downloadJobs.filter(
    (j) => getJobCls(j.status) === "completed"
  ).length;
  const failedCount = downloadJobs.filter(
    (j) => getJobCls(j.status) === "failed"
  ).length;

  /* ─── Download completed file ─── */
  const downloadFile = (job) => {
    const url = job.storagePath;
    if (!url) {
      toast.error("File URL not available.");
      return;
    }
    const link = document.createElement("a");
    link.href = url;
    link.download = `Order_Report_${job.queryParams?.startDate}_${job.queryParams?.endDate}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  /* ─── Pagination items ─── */
  const renderPaginationItems = () => {
    const total = paginationData.totalPages;
    if (total <= 1) return null;
    const items = [];
    if (total > 15) {
      if (currentPage > 3)
        items.push(
          <Pagination.Item key="1" onClick={() => handlePageChange(1)}>1</Pagination.Item>
        );
      if (currentPage > 4) items.push(<Pagination.Ellipsis key="el1" />);
      for (let i = 0; i < 5; i++) {
        const p = currentPage > 3 ? currentPage - 2 + i : i + 1;
        if (p <= total)
          items.push(
            <Pagination.Item key={p} active={p === currentPage} onClick={() => handlePageChange(p)}>
              {p}
            </Pagination.Item>
          );
      }
      if (currentPage < total - 3) items.push(<Pagination.Ellipsis key="el2" />);
      if (currentPage < total - 2)
        items.push(
          <Pagination.Item key={total} onClick={() => handlePageChange(total)}>
            {total}
          </Pagination.Item>
        );
    } else {
      for (let i = 1; i <= total; i++)
        items.push(
          <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
            {i}
          </Pagination.Item>
        );
    }
    return items;
  };

  /* ─── Print Invoice ─── */
  // PREVIOUS FUNCTION 
  //   const handlePrintInvoice = (orderData) => {
  //     console.log("orderData :", orderData);
  //     const order = orderData?.selectedOrder || orderData?.newOrder;
  //     const win = window.open("", "", "width=820,height=700");
  //     const outletName = order?.outlet?.name || "XPANSE CAFE";
  //     const outletAddress = order?.outlet?.address || "";
  //     const rows = (orderData?.orderItems || [])
  //       .map(
  //         (item) => `
  //         <tr>
  //           <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0">
  //             <div style="font-weight:600;font-size:13px">${item.product?.name || "Product"}</div>
  //             ${(item?.addons || [])
  //             .map(
  //               (a) =>
  //                 `<span style="font-size:11px;color:#666;display:block;padding-left:10px">+ ${a.selectedValue} (₹${a.price?.toFixed(2)})</span>`
  //             )
  //             .join("")}
  //           </td>
  //           <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;text-align:center">${item.quantity}</td>
  //           <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;text-align:right">₹${item.rate?.toFixed(2)}</td>
  //           <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;text-align:right;font-weight:600">
  //             ₹${(item.rate * item.quantity + (item?.addons?.reduce((s, a) => s + a.price, 0) || 0) * item.quantity).toFixed(2)}
  //           </td>
  //         </tr>`
  //       )
  //       .join("");

  //     win.document.write(`<!DOCTYPE html>
  // <html>
  // <head>
  //   <title>Invoice</title>
  //   <style>
  //     *{margin:0;padding:0;box-sizing:border-box}
  //     body{font-family:sans-serif;background:#f5f5f0}
  //     .page{max-width:720px;margin:30px auto;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 8px 40px rgba(0,0,0,.1)}
  //     .header{background:linear-gradient(135deg,#1a1a2e,#0f3460);padding:36px 40px 28px}
  //     .store-name{font-size:26px;font-weight:700;color:#fff}
  //     .invoice-label{display:inline-block;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.2);color:#fff;font-size:11px;font-weight:600;letter-spacing:2px;text-transform:uppercase;padding:5px 14px;border-radius:20px;margin-top:16px}
  //     .meta-strip{display:grid;grid-template-columns:repeat(3,1fr);border-bottom:1px solid #f0f0f0}
  //     .meta-cell{padding:18px 22px;border-right:1px solid #f0f0f0}
  //     .meta-cell:last-child{border-right:none}
  //     .meta-label{font-size:10px;font-weight:600;color:#999;text-transform:uppercase;letter-spacing:1px;margin-bottom:5px}
  //     .meta-value{font-size:13px;font-weight:600}
  //     table{width:100%;border-collapse:collapse}
  //     thead tr{background:#f8f8f6}
  //     thead th{padding:10px 12px;font-size:10px;font-weight:700;color:#888;text-transform:uppercase}
  //     .items-section{padding:24px}
  //     .total-row{display:flex;justify-content:space-between;padding:7px 12px;font-size:13px;color:#555}
  //     .grand-total{background:linear-gradient(135deg,#1a1a2e,#0f3460);margin:16px 24px 24px;border-radius:12px;padding:18px 20px;display:flex;justify-content:space-between;align-items:center}
  //     .grand-total span:first-child{font-size:13px;color:rgba(255,255,255,.7)}
  //     .grand-total span:last-child{font-size:22px;font-weight:700;color:#fff}
  //     .footer{background:#f8f8f6;padding:18px 24px;display:flex;justify-content:space-between;border-top:1px solid #eee}
  //     @media print{body{background:#fff}.page{box-shadow:none;margin:0;border-radius:0}}
  //   </style>
  // </head>
  // <body onload="window.print();window.close()">
  //   <div class="page">
  //     <div class="header">
  //       <div class="store-name">${outletName}</div>
  //       <div style="font-size:11.5px;color:rgba(255,255,255,.65);margin-top:8px">${outletAddress}</div>
  //       <div class="invoice-label">Tax Invoice</div>
  //     </div>
  //     <div class="meta-strip">
  //       <div class="meta-cell">
  //         <div class="meta-label">Invoice No</div>
  //         <div class="meta-value">#${order.order_sequence}${order.order_no}</div>
  //       </div>
  //       <div class="meta-cell">
  //         <div class="meta-label">Date</div>
  //         <div class="meta-value">${fmtViewDate(order.createdAt)}</div>
  //         <div style="font-size:11px;color:#888">${fmtViewTime(order.createdAt)}</div>
  //       </div>
  //       <div class="meta-cell">
  //         <div class="meta-label">Status</div>
  //         <span>${order.orderStatus}</span>
  //       </div>
  //     </div>
  //     <div class="items-section">
  //       <table>
  //         <thead>
  //           <tr>
  //             <th>Description</th>
  //             <th style="text-align:center">Qty</th>
  //             <th style="text-align:right">Price</th>
  //             <th style="text-align:right">Amount</th>
  //           </tr>
  //         </thead>
  //         <tbody>${rows}</tbody>
  //       </table>
  //       <div style="border-top:2px solid #f0f0f0;margin-top:4px">
  //         <div class="total-row"><span>Subtotal (Taxable)</span><span>₹${order.totalTaxable?.toFixed(2)}</span></div>
  //         <div class="total-row" style="color:#dc3545"><span>Discount</span><span>− ₹${order.totalDiscount?.toFixed(2)}</span></div>
  //         <div class="total-row" style="color:#f59e0b"><span>Tax</span><span>+ ₹${order.totalTaxAmount?.toFixed(2)}</span></div>
  //       </div>
  //     </div>
  //     <div class="grand-total">
  //       <span>GRAND TOTAL</span>
  //       <span>₹${order.grandTotal?.toFixed(2)}</span>
  //     </div>
  //     <div style="text-align:center;padding:14px;font-size:12px;color:#888">
  //       Thank you for choosing ${outletName}! 🙏
  //     </div>
  //     <div class="footer">
  //       <div>Computer generated invoice</div>
  //       <div>Powered by Xpanse POS</div>
  //     </div>
  //   </div>
  // </body>
  // </html>`);
  //     win.document.close();
  //   };

  const handlePrintInvoice = (orderData) => {
    const order = orderData?.newOrder || orderData?.order || orderData?.selectedOrder;
    console.log("Order Data in PrintInvoice", orderData);

    const orderItems = orderData?.orderItems || order?.orderItems || [];

    // ── Customer Info ──
    let customerInfo = '';
    let subscriptionInfo = '';

    if (order?.paymentMode === "SUBSCRIBED") {
      subscriptionInfo = `
    <span style="font-size:8px;">Subscription Order</span><br/>
    <span style="font-size:10px;">${order?.subscriptionId?.title || ''}</span>
  `;
    }

    if (order?.source === "QUICK-ORDER") {
      customerInfo = `
    <span style="font-size:10px;color:#2563eb;">
      QR ORDER [Mobile]
    </span>
  `;
    } else if (order?.source === "QUICK-SERVE") {
      customerInfo = `
    <span style="font-size:10px;color:#16a34a;">
      QUICK SERVE [POS]
    </span>
  `;
    } else if (order?.kioskUser) {
      customerInfo = `
    <span style="font-size:10px;">
      ${order?.kioskUser?.name || 'N/A'}<br/>
      ${(order?.kioskUser?.phone || order?.kioskUser?.mobile || '').replace(/\d(?=\d{4})/g, '*')}<br/>
    </span>
  `;
    } else if (
      order?.paymentMode === "COMPLIMENTARY" ||
      order?.grandTotal === 0
    ) {
      customerInfo = `
    <div style="padding:0;margin:0;display:flex;flex-direction:column;">
      <span style="font-size:10px;">Complimentary Order</span>
      <span style="font-size:8px;">${(order?.comments || '').substring(0, 40)}</span>
    </div>
  `;
    } else {
      const userName =
        order?.user?.name ||
        order?.outletUser?.name ||
        'N/A';

      const userMobile =
        order?.user?.mobile ||
        order?.outletUser?.mobile ||
        '';

      customerInfo = `
    <span style="font-size:10px;">
      ${userName}<br/>
      ${userMobile.replace(/\d(?=\d{4})/g, '*')}<br/>
      ${subscriptionInfo}
    </span>
  `;
    }

    // ── Tax split ──
    const totalTaxAmount = order?.totalTaxAmount || 0;
    const taxDivide = totalTaxAmount / 2;

    // ── QR Code (inline SVG fallback — no React dependency) ──
    // Simple placeholder; swap for a real QR lib if needed
    const qrCodeSvg = `
    <svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
      <rect width="80" height="80" fill="#fff"/>
      <text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle"
            font-size="7" font-family="monospace" fill="#333">
        Scan to Download
      </text>
    </svg>
  `;

    // ── Items rows ──
    const rows = orderItems.map((item) => {
      const addonPriceSum = (item?.addons || []).reduce((s, a) => s + (a?.price || a?.offerPrice || 0), 0);
      const taxable = item?.taxable ?? item?.rate ?? 0;

      return `
      <tr>
        <td>
          ${item?.product?.name || 'Product'}<br/>
          ${item?.addons?.length > 0 ? `
            <small>
              ${item.addons.map(a => `- ${a.selectedValue}<br/>`).join('')}
            </small>
          ` : ''}
        </td>
        <td style="text-align:center;vertical-align:top;">${item?.quantity}</td>
        <td style="text-align:right;vertical-align:top;">
          ${taxable.toFixed(2)}<br/>
          <small>
            ${item?.addons?.length > 0
          ? item.addons.map(a => `+ ${(a?.offerPrice ?? a?.price ?? 0).toFixed(2)}<br/>`).join('')
          : ''}
          </small>
        </td>
      </tr>
    `;
    }).join('');

    // ── Outlet info (from order.outlet since admin doesn't have outletData) ──
    console.log("ORder in handle Print :", order);

    const outlet = order?.outlet || {};
    const outletName = outlet?.name || 'XPANSE CAFE';
    const outletAddress = [outlet?.address, outlet?.city, outlet?.state, outlet?.pincode]
      .filter(Boolean).join(', ');
    const outletPhone = outlet?.phone || '';
    const gstin = outlet?.gstin || '';
    const fssai = outlet?.fssai || '';

    const gstHTML = gstin ? `<p style="text-transform:uppercase;margin:12px 0 0;padding:0;">GST No. ${gstin}</p>` : '';
    const fssaiHTML = fssai ? `<p style="text-transform:uppercase;margin:0;padding:0;">FSSAI No. ${fssai}</p>` : '';

    const printContent = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8"/>
      <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400;700&display=swap" rel="stylesheet">
      <title>XPANSE</title>
      <style>
        * { margin:0; padding:0; box-sizing:border-box; }
        body {
          font-family: "Roboto Mono", monospace;
          font-weight: 700;
          width: 100%;
          max-width: 300px;
          margin: 0 auto;
          padding: 8px;
          font-size: 12px;
        }
        center { text-align: center; }
        p  { font-size:10px; margin-bottom:6px; }
        h1 { padding:0; margin:0; }
        h3 { font-size:14px; }
        h5 { font-size:11px; margin-top:2px; }
        table {
          width: 100%;
          text-transform: uppercase;
          font-weight: 700;
          border-collapse: collapse;
        }
        table th, table td { font-size:12px; padding:5px; vertical-align:top; }
        table thead td    { text-align:left; }
        table tfoot td    { text-align:right; }
        small { font-size:10px; font-weight:400; }
        .divider { border-top:1px solid #000; }
        @media print {
          body { max-width:100%; margin:0; padding:0; }
        }
      </style>
    </head>
    <body >

      <center>
        <img style="width:20%;" src="${invoice}" />
        <p style="font-size:20px;font-weight:900;letter-spacing:2px;margin:4px 0;">
          ${outletName}
        </p>
        ${gstHTML}
        ${fssaiHTML}
        <p style="margin:4px 0;">${outletAddress}</p>
        ${outletPhone ? `<p style="margin:0 0 8px;">+91 ${outletPhone}</p>` : ''}
      </center>

      <table cellpadding="5" cellspacing="0">
        <thead>

          <!-- Order Details + Customer Info -->
          <tr>
            <td>
              <p style="font-size:12px;font-weight:700;margin:0 0 3px;">ORDER DETAILS</p>
              <span style="font-size:10px;">
                INV NO: #${order?.order_sequence}${order?.order_no}<br/>
                DATE: ${new Date(order?.createdAt).toLocaleDateString('en-IN', {
      day: '2-digit', month: '2-digit', year: 'numeric'
    })}<br/>
                TIME: ${new Date(order?.createdAt).toLocaleTimeString('en-US', {
      hour: '2-digit', minute: '2-digit', hour12: false
    })}<br/>
                ITEM(S): ${orderItems.length} Nos.
              </span>
            </td>
            <td colspan="2">
              <p style="font-size:12px;font-weight:700;margin:0 0 3px;">CUSTOMER INFO</p>
              ${customerInfo}
            </td>
          </tr>

          <!-- Order Type + Payment -->
          <tr>
            <td><b>${order?.ordersType || order?.source || 'N/A'}</b></td>
            <td colspan="2"><b>${order?.paymentStatus === 'PAID' ? 'PAID' : order?.paymentStatus || 'PAID'}</b></td>
          </tr>

          <!-- TAX INVOICE heading -->
          <tr>
            <th colspan="3" style="border-top:1px solid #000;text-align:center;">TAX INVOICE</th>
          </tr>

          <!-- Column headers -->
          <tr>
            <th style="text-align:left;border-bottom:1px solid #000;">ITEM NAME</th>
            <th style="text-align:center;border-bottom:1px solid #000;">QTY</th>
            <th style="text-align:right;border-bottom:1px solid #000;">PRICE (Rs.)</th>
          </tr>

        </thead>

        <tbody>
          ${rows}
        </tbody>

        <tfoot>
          <!-- Subtotal / fees / tax -->
          <tr>
            <td colspan="2" style="text-align:left;">
              <b>SUB TOTAL</b><br/>
              ${order?.platformFees > 0
        ? `<small>PLATFORM FEES</small><br/>`
        : ''}
              ${order?.packingCharges > 0 || order?.packagingCharges > 0
        ? `<small>PACKAGING CHARGES</small><br/>`
        : ''}
              <small>
                TAX<br/>
                CGST: (₹${taxDivide.toFixed(2)})<br/>
                SGST: (₹${taxDivide.toFixed(2)})
              </small>
            </td>
            <td style="text-align:right;">
              <b>${(order?.totalTaxable || 0).toFixed(2)}</b><br/>
              ${order?.platformFees > 0
        ? `<small>${Number(order.platformFees).toFixed(2)}</small><br/>`
        : ''}
              ${order?.packingCharges > 0 || order?.packagingCharges > 0
        ? `<small>${Number(order?.packingCharges || order?.packagingCharges || 0).toFixed(2)}</small><br/>`
        : ''}
              <small>${totalTaxAmount.toFixed(2)}</small>
            </td>
          </tr>

          <!-- Delivery charges -->
          ${order?.deliveryCharges > 0 ? `
          <tr>
            <td colspan="2" style="text-align:left;"><small>DELIVERY CHARGES</small></td>
            <td style="text-align:right;"><small>${Number(order.deliveryCharges).toFixed(2)}</small></td>
          </tr>` : ''}

          <!-- Discount -->
          ${order?.totalDiscount > 0 ? `
          <tr>
            <td colspan="2" style="text-align:left;"><small>DISCOUNT</small></td>
            <td style="text-align:right;"><small>- ${Number(order.totalDiscount).toFixed(2)}</small></td>
          </tr>` : ''}

          <!-- Coupon -->
          ${order?.coupon ? `
          <tr>
            <td colspan="3" style="text-align:left;">
              <small>COUPON: ${order.coupon?.couponCode || ''}</small>
            </td>
          </tr>` : ''}

          <!-- Grand Total -->
          <tr>
            <td colspan="2" style="text-align:left;border-top:1px solid #000;">
              <b>GRAND TOTAL</b>
            </td>
            <td style="border-top:1px solid #000;text-align:right;">
              <b>₹ ${(order?.grandTotal || 0).toFixed(2)}</b>
            </td>
          </tr>

        </tfoot>
      </table>

      <!-- Footer -->
      <center style="margin-top:15px;">
        ${qrCodeSvg}
        <h2 style="font-size:24px;margin:6px 0;">
          #${order?.order_sequence}${order?.order_no}
        </h2>
        <h3>THANK YOU.... VISIT AGAIN</h3>
        <h5>${new Date().toLocaleTimeString('en-US', {
          hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
        })}</h5>
      </center>

    </body>
    </html>
  `;

    // ── Print via iframe (same as POS) ──
    const printIframe = document.createElement('iframe');
    printIframe.style.display = 'none';
    document.body.appendChild(printIframe);
    const printDocument = printIframe.contentWindow.document;
    printDocument.write(printContent);
    printDocument.close();
    printIframe.onload = () => {
      printIframe.contentWindow.focus();
      printIframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(printIframe);
      }, 1500);
    };
  };

  const selectStyles = {
    control: (p, s) => ({
      ...p,
      borderRadius: 6,
      minHeight: 38,
      height: 38,
      borderColor: s.isFocused ? "#2563eb" : "#e2e6ea",
      boxShadow: s.isFocused ? "0 0 0 3px rgba(37,99,235,.1)" : "none",
      "&:hover": { borderColor: s.isFocused ? "#2563eb" : "#e2e6ea" },
      fontSize: 13.5,
    }),
    valueContainer: (p) => ({ ...p, padding: "0 8px", height: 36 }),
    indicatorsContainer: (p) => ({ ...p, height: 36 }),
    placeholder: (p) => ({ ...p, color: "#9ca3af" }),
    option: (p, s) => ({
      ...p,
      fontSize: 13.5,
      background: s.isSelected ? "#2563eb" : s.isFocused ? "#eff6ff" : "#fff",
    }),
  };

  const getSingleOrderDetails = async (orderId) => {
    setSingleOrderDetailsLoading(true);
    try {
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axiosInstance.get(`order/get-order-details/${orderId}`, { headers });
      console.log("Order Details Response :", response);
      let order = response?.data?.data;
      let newOrder = order?.order;
      const result = {
        newOrder,
        orderItems: order.orderItems || [],
        orderStatusLogs: order.orderStatusLogs || [],
      };
      setSingleOrderDetailsLoading(false);
      setSelectedOrder(result);
      return result;           // ← add this
    } catch (error) {
      console.error("Error fetching order details:", error);
    } finally {
      setSingleOrderDetailsLoading(false);
    }
  };

  const isMultiSelected = selectedOutlet && selectedOutlet.length > 1;

  /* ════════════════════════════════════════════
     RENDER
  ════════════════════════════════════════════ */
  return (
    <React.Fragment>
      <style>{CSS}</style>
      <Header onSkin={setSkin} />
      <div
        className="main main-app"
        style={{ background: "#f0f2f5", minHeight: "100vh", padding: "24px" }}
      >
        <div className="or-card">

          {/* ── Page Header ── */}
          <div className="or-header">
            <div className="or-header-title">
              <i className="bi bi-bag me-2"></i> ORDERS REPORT
            </div>
            <div className="or-header-right">
              {/* Downloads Manager Button — in header */}
              <button
                id="or-dm-fab"
                className={`or-dm-fab${pendingCount > 0 ? " has-active" : ""}`}
                onClick={() => setDmOpen((o) => !o)}
                title="Download Manager"
              >
                <CloudDownload size={15} />
                Downloads
                {pendingCount > 0 && (
                  <span className="or-dm-badge or-pulse">{pendingCount}</span>
                )}
                {pendingCount === 0 && completedCount > 0 && (
                  <span className="or-dm-badge" style={{ background: "#059669" }}>
                    {completedCount}
                  </span>
                )}
              </button>

              <button
                className="or-back-btn"
                onClick={() => navigate("/reports/all-reports")}
              >
                <ArrowLeft size={14} /> Back to Reports
              </button>
            </div>
          </div>

          {/* ════════════════════════════════════
              FILTERS
          ════════════════════════════════════ */}
          <div className="or-filters">

            {/* ── Top row: 5 equal columns ── */}
            <div className="or-filter-grid">

              {/* 1. Outlet */}
              <div className="or-filter-col">
                <OutletSelect
                  isMulti
                  value={selectedOutlet}
                  onChange={setSelectedOutlet}

                  // onChange={(opts) => {
                  //   const arr = Array.isArray(opts) ? opts : opts ? [opts] : [];
                  //   if (arr.length > 1) {
                  //     // toast.info('Multiple outlet selection is temporarily disabled.', {
                  //     //   position: 'top-right', autoClose: 2500, theme: 'light',
                  //     // });
                  //     setSelectedOutlet(arr.slice(0, 1));
                  //   } else {
                  //     setSelectedOutlet(arr);
                  //   }
                  // }}
                  required
                />
              </div>

              {/* 2. Start Date */}
              <div className="or-filter-col">
                <label className="or-filter-label">
                  <i className="bi bi-calendar me-1"></i> Start Date
                </label>
                <DatePicker
                  selected={startDate}
                  onChange={setStartDate}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Start Date"
                  className="form-control"
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  maxDate={new Date()}
                />
              </div>

              {/* 3. End Date */}
              <div className="or-filter-col">
                <label className="or-filter-label">
                  <i className="bi bi-calendar-event me-1"></i> End Date
                </label>
                <DatePicker
                  selected={endDate}
                  onChange={setEndDate}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="End Date"
                  className="form-control"
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                />
              </div>

              {/* 4. Order Status */}
              <div className="or-filter-col">
                <label className="or-filter-label">Order Status</label>
                <select
                  className="or-filter-select"
                  value={orderStatus}
                  onChange={(e) => setOrderStatus(e.target.value)}
                >
                  <option value="">All Status</option>
                  <option value="CONFIRMED">Confirmed</option>
                  <option value="CANCELLED">Cancelled</option>
                  <option value="COMPLETED">Completed</option>
                  <option value="DELIVERED">Delivered</option>
                </select>
              </div>

              {/* 5. Order Type */}
              <div className="or-filter-col">
                <label className="or-filter-label">Order Type</label>
                <select
                  className="or-filter-select"
                  value={orderType}
                  onChange={(e) => setOrderType(e.target.value)}
                >
                  <option value="">All Types</option>
                  <option value="APP">App / Website</option>
                  <option value="KIOSK">Kiosk</option>
                  <option value="SUBSCRIBED">Subscription</option>
                  <option value="COMPLIMENTARY">Complimentary</option>
                  <option value="QUICK-ORDER">Quick Order from mobile</option>
                  <option value="QUICK-SERVE">Quick Serve Order from Pos</option>
                </select>
              </div>
            </div>

            {/* ── Bottom row: Actions ── */}
            <div className="or-filter-bottom">

              {/* Generate / Schedule button */}
              <button
                className="or-generate-btn"
                onClick={handleSubmit}
                disabled={
                  subBtnLoading ||
                  !selectedOutlet ||
                  selectedOutlet.length === 0 ||
                  !startDate ||
                  !endDate
                }
              >
                {subBtnLoading ? (
                  <Spinner size="sm" animation="border" />
                ) : isMultiSelected || isLongRange(startDate, endDate) ? (
                  <>
                    <FileEarmarkSpreadsheet size={14} /> Schedule Download
                  </>
                ) : (
                  <>
                    <Search size={13} /> Generate Report
                  </>
                )}
              </button>

              {/* Multi-outlet warning */}
              {(isMultiSelected || isLongRange(startDate, endDate)) && (
                <span
                  style={{
                    fontSize: 12, color: "#d97706", fontWeight: 500,
                    display: "flex", alignItems: "center", gap: 5,
                  }}
                >
                  <ExclamationTriangle size={12} />
                  {isMultiSelected
                    ? `${selectedOutlet.length} outlets — will queue as Excel download`
                    : "Date range >90 days — will queue as Excel download"}
                </span>
              )}

              {/* Search bar — single outlet only */}
              {!isMultiSelected && (
                <>
                  <div style={{ width: 1, height: 24, background: "#e2e6ea", margin: "0 4px" }} />
                  <div className="or-search-wrap">
                    <Search size={13} className="search-icon" />
                    <input
                      className="or-search-input"
                      placeholder="Search by name, order no, mobile…"
                      value={searchText}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                        setIsClicked(true);
                      }}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") handleSubmit();
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          {/* ══ MULTI-OUTLET INFO BANNER ══ */}
          {clicked && isMultiOutlet && (
            <div className="or-multi-notice" style={{ marginBottom: 8 }}>
              <span style={{ fontSize: 18, flexShrink: 0 }}>📥</span>
              <div className="or-multi-notice-text">
                <strong>
                  Download queued for {selectedOutlet?.length} outlets.
                </strong>{" "}
                Your report is being generated in the background. Click the{" "}
                <strong>Downloads</strong> button in the top-right to track progress and
                download once ready. You can navigate freely.
              </div>
            </div>
          )}

          {/* ══ SINGLE OUTLET MODE ══ */}
          {clicked && !isMultiOutlet && (
            <>
              {/* KPI Strip */}
              <div className="or-kpi-strip" style={{ gridTemplateColumns: "repeat(8, 1fr)" }}>

                {/* Total Orders — with/without coupon */}
                <div className="or-kpi-cell">
                  <div className="or-kpi-label">Total Orders</div>
                  <div className="or-kpi-value ink">{summaryData?.totalOrderCount?.toLocaleString() || 0}</div>
                  <div className="or-kpi-sub-row">
                    <div className="or-kpi-sub-item">
                      <div className="or-kpi-sub-label">W/ Coup</div>
                      <div className="or-kpi-sub-value amber">{summaryData?.totalOrdersWithCouponCount || 0}</div>
                    </div>
                    <div className="or-kpi-sub-item">
                      <div className="or-kpi-sub-label">W/O Coup</div>
                      <div className="or-kpi-sub-value ink">{summaryData?.totalOrdersWithoutCouponCount || 0}</div>
                    </div>
                  </div>
                </div>

                {/* Cancelled — count + amount */}
                <div className="or-kpi-cell">
                  <div className="or-kpi-label">Cancelled</div>
                  <div className="or-kpi-value red">{summaryData?.totalCancelledOrderCount || 0}</div>
                  <div className="or-kpi-sub-row">
                    <div className="or-kpi-sub-item">
                      <div className="or-kpi-sub-label">Count</div>
                      <div className="or-kpi-sub-value red">{summaryData?.totalCancelledOrderCount || 0}</div>
                    </div>
                    <div className="or-kpi-sub-item">
                      <div className="or-kpi-sub-label">Amount</div>
                      <div className="or-kpi-sub-value red">₹{summaryData?.cancelledOrderAmount?.toFixed(2) || "0.00"}</div>
                    </div>
                  </div>
                </div>

                {/* Complimentary — count + taxable amount + non-complimentary count */}
<div className="or-kpi-cell">
  <div className="or-kpi-label">Complimentary</div>
  <div className="or-kpi-value purple">
    {summaryData?.totalComplimentaryOrderCount || 0}
  </div>
  <div className="or-kpi-sub-row">
    {/* <div className="or-kpi-sub-item">
      <div className="or-kpi-sub-label">Taxable</div>
      <div className="or-kpi-sub-value purple">
        ₹{summaryData?.totalComplimentaryOrdersTaxable?.toFixed(2) || "0.00"}
      </div>
    </div> */}
    {/* <div className="or-kpi-sub-item">
      <div className="or-kpi-sub-label">Compl Orders</div>
      <div className="or-kpi-sub-value ink">
        {summaryData?.totalComplimentaryOrderCount || 0}
      </div>
    </div> */}
    <div></div>
    <div className="or-kpi-sub-item">
      <div className="or-kpi-sub-label">Taxable</div>
      <div className="or-kpi-sub-value ink">
        ₹{summaryData?.totalComplimentaryOrdersTaxable?.toFixed(2) || "0.00"}
      </div>
    </div>
  </div>
</div>

                {/* Kiosk — count + amount */}
                <div className="or-kpi-cell">
                  <div className="or-kpi-label">Kiosk</div>
                  <div className="or-kpi-value teal">{summaryData?.totalKioskOrderCount || 0}</div>
                  <div className="or-kpi-sub-row">
                    <div className="or-kpi-sub-item">
                      <div className="or-kpi-sub-label">Count</div>
                      <div className="or-kpi-sub-value teal">{summaryData?.totalKioskOrderCount || 0}</div>
                    </div>
                    <div className="or-kpi-sub-item">
                      <div className="or-kpi-sub-label">Amount</div>
                      <div className="or-kpi-sub-value teal">₹{summaryData?.kioskGrandTotalAmount?.toFixed(2) || "0.00"}</div>
                    </div>
                  </div>
                </div>

                <div className="or-kpi-cell">
                  <div className="or-kpi-label">Discount</div>
                  <div className="or-kpi-value coral">₹{summaryData?.totalDiscountAmount?.toFixed(2) || "0.00"}</div>
                </div>

                <div className="or-kpi-cell">
                  <div className="or-kpi-label">Tax</div>
                  <div className="or-kpi-value purple">₹{summaryData?.totalTaxAmount?.toFixed(2) || "0.00"}</div>
                </div>

                <div className="or-kpi-cell">
                  <div className="or-kpi-label">Taxable</div>
                  <div className="or-kpi-value green">₹{summaryData?.totalTaxableAmount?.toFixed(2) || "0.00"}</div>
                </div>

                <div className="or-kpi-cell">
                  <div className="or-kpi-label">Grand Total</div>
                  <div className="or-kpi-value blue">₹{summaryData?.grandTotalAmount?.toFixed(2) || "0.00"}</div>
                </div>

              </div>

              {/* ── Toolbar ── */}
              <div className="or-toolbar" style={{ marginTop: summaryData ? 20 : 0 }}>
                {paginationData.totalPages > 1 && (
                  <Pagination className="mb-0" size="sm">
                    <Pagination.Prev
                      disabled={currentPage === 1}
                      onClick={() => handlePageChange(currentPage - 1)}
                    />
                    {renderPaginationItems()}
                    <Pagination.Next
                      disabled={currentPage === paginationData.totalPages}
                      onClick={() => handlePageChange(currentPage + 1)}
                    />
                  </Pagination>
                )}
                <div className="or-toolbar-left" />
                <div className="or-toolbar-right">
                  {orders.length > 0 && (
                    <span className="or-page-info">
                      Page {currentPage} of {paginationData.totalPages}
                    </span>
                  )}

                  {/* Download Excel Button */}
                  <button
                    className="or-toolbar-btn"
                    style={
                      orders.length > 0
                        ? { borderColor: "#059669", color: "#059669", background: "#ecfdf5" }
                        : {}
                    }
                    onClick={handleSingleOutletDownload}
                    disabled={downloadBtnLoading || orders.length === 0}
                    title="Download current results as Excel"
                  >
                    {downloadBtnLoading ? (
                      <Spinner size="sm" animation="border" />
                    ) : (
                      <>
                        <FileEarmarkSpreadsheet size={13} /> Download Excel
                      </>
                    )}
                  </button>

                  {/* Per-page selector */}
                  <div className="or-per-page">
                    <span>Show</span>
                    <select
                      value={recordsPerPage}
                      onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                    >
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={200}>200</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* ── Orders Table ── */}
              {loading ? (
                <div className="or-loading">
                  <Spinner animation="border" variant="primary" />
                  <span style={{ fontSize: 13.5 }}>Loading orders…</span>
                </div>
              ) : (
                <div className="or-table-wrap">
                  <table className="or-table">
                    <thead>
                      <tr>
                        <th style={{ width: 44 }}>Sr</th>
                        <th style={{ width: 130 }}>Date / Time</th>
                        <th style={{ width: 120 }}>Order No</th>
                        <th style={{ width: 160 }}>Customer</th>
                        <th style={{ width: 120 }}>Status</th>
                        <th style={{ width: 120, textAlign: "center" }}>Arrival</th>
                        <th style={{ width: 100, textAlign: "right" }}>Taxable</th>
                        <th style={{ width: 80, textAlign: "right" }}>Tax</th>
                        <th style={{ width: 90, textAlign: "right" }}>Discount</th>
                        <th style={{ width: 100, textAlign: "right" }}>Total</th>
                        <th style={{ width: 90, textAlign: "center" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orders.length > 0 ? (
                        orders.map((order, idx) => {
                          const openDetails = () => {
                            getSingleOrderDetails(order._id);
                            setViewDetailsModal(true);
                          };
                          return (
                            <tr key={order._id || idx}>
                              <td
                                style={{ color: "#9ca3af", fontSize: 12 }}
                                className="row-clickable"
                                onClick={openDetails}
                              >
                                {(currentPage - 1) * recordsPerPage + idx + 1}
                              </td>
                              <td className="row-clickable" onClick={openDetails}>
                                <div style={{ fontSize: 12.5, fontWeight: 500 }}>
                                  {fmtViewDate(order.createdAt)}
                                </div>
                                <div style={{ fontSize: 11.5, color: "#9ca3af" }}>
                                  {fmtViewTime(order.createdAt)}
                                </div>
                              </td>
                              <td className="row-clickable" onClick={openDetails}>
                                <span className="or-orderno">
                                  {order.order_sequence}{order.order_no}
                                </span>
                              </td>
                              <td className="row-clickable" onClick={openDetails}>
                                {order.source === "QUICK-ORDER" || order.source === "QUICK-SERVE" ? (
                                  <>
                                  <div
                                    className={
                                      order?.source === "QUICK-ORDER"
                                        ? "text-danger"
                                        : "text-success"
                                    }
                                    style={{ fontWeight: 500, fontSize: 12 }}>
                                    {order.source === "QUICK-ORDER" ? "QR ORDER [Mobile]" : `QUICK SERVE [POS] `}
                                  </div>
                                  <div style={{ fontSize: 11.5, color: "#2563eb" }}>
                                    {order.customerPhoneNumber ||
                                      ""}
                                  </div>
                                  </>
                                ) : (
                                  <>
                                    <div style={{ fontWeight: 600, fontSize: 13 }}>
                                      {order.user?.name ||
                                        order.outletUser?.name ||
                                        order.kioskUser?.name ||
                                        "N/A"}
                                    </div>
                                    <div style={{ fontSize: 11.5, color: "#2563eb" }}>
                                      {order.user?.mobile ||
                                        order.outletUser?.mobile ||
                                        order.kioskUser?.mobile ||
                                        ""}
                                    </div>
                                    {getOrderUserBadge(order)}
                                  </>
                                )}

                              </td>
                              <td className="row-clickable" onClick={openDetails}>
                                <span className={`or-badge ${getStatusClass(order.orderStatus)}`}>
                                  <span className="or-badge-dot" style={{ background: "currentColor" }} />
                                  {order.orderStatus}
                                </span>
                              </td>
                              <td
                                className="row-clickable"
                                style={{ textAlign: "center" }}
                                onClick={openDetails}
                              >
                                {order.orderArrivalStatus === "DELAYED" ? (
                                  <span className="or-arrival delayed">
                                    ⏱ +{order.delayedArrival}m
                                  </span>
                                ) : order.orderArrivalStatus === "EARLY" ? (
                                  <span className="or-arrival early">
                                    ⚡ -{order.earlyArrival}m
                                  </span>
                                ) : (
                                  <span className="or-arrival ontime">✓ On Time</span>
                                )}
                              </td>
                              <td className="row-clickable" style={{ textAlign: "right" }} onClick={openDetails}>
                                <span className="or-amount green">₹{order.totalTaxable?.toFixed(2)}</span>
                              </td>
                              <td className="row-clickable" style={{ textAlign: "right" }} onClick={openDetails}>
                                <span className="or-amount amber">₹{order.totalTaxAmount?.toFixed(2)}</span>
                              </td>
                              <td className="row-clickable" style={{ textAlign: "right" }} onClick={openDetails}>
                                <span className="or-amount red">₹{order.totalDiscount?.toFixed(2)}</span>
                              </td>
                              <td className="row-clickable" style={{ textAlign: "right" }} onClick={openDetails}>
                                <span className="or-amount blue">₹{order.grandTotal?.toFixed(2)}</span>
                              </td>
                              <td
                                style={{ textAlign: "center" }}
                                ref={openDropdownId === (order._id || idx) ? dropdownRef : null}
                              >
                                <div className="or-dropdown" style={{ display: "inline-block" }}>
                                  <button
                                    className="or-action-btn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpenDropdownId((p) =>
                                        p === (order._id || idx) ? null : order._id || idx
                                      );
                                    }}
                                  >
                                    Actions <ChevronDown size={11} />
                                  </button>
                                  {openDropdownId === (order._id || idx) && (
                                    <div
                                      className="or-dropdown-menu"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <button
                                        className="or-dropdown-item"
                                        onClick={() => {
                                          openDetails();
                                          setOpenDropdownId(null);
                                        }}
                                      >
                                        <Eye size={14} style={{ color: "#059669" }} />
                                        View Details
                                      </button>
                                      {(reportAccess?.includes("OrdersReport:update") ||
                                        email === "contact@xpansecafe.com") &&
                                        order.orderStatus !== "CANCELLED" &&
                                        new Date(order.createdAt).toDateString() ===
                                        currentDate?.toDateString() &&
                                        order.paymentMode !== "COMPLIMENTARY" && (
                                          <button
                                            className="or-dropdown-item danger"
                                            onClick={() => {
                                              handleOpenCancelOrderModal(order);
                                              setOpenDropdownId(null);
                                            }}
                                          >
                                            <XCircle size={14} /> Cancel Order
                                          </button>
                                        )}
                                      <button
                                        className="or-dropdown-item"
                                        onClick={async () => {
                                          const details = await getSingleOrderDetails(order._id);

                                          handlePrintInvoice({
                                            selectedOrder: details?.newOrder || order,
                                            orderItems: details.orderItems || [],
                                          });
                                          setOpenDropdownId(null);
                                        }}
                                      >
                                        <Receipt size={14} style={{ color: "#2563eb" }} />
                                        Print Invoice
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={11}>
                            <div className="or-empty" style={{ padding: "40px 24px" }}>
                              <div className="or-empty-icon">📋</div>
                              <div className="or-empty-title">No orders found</div>
                              <div className="or-empty-sub">Try adjusting your filters</div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}

              {/* ── Pagination ── */}
              {paginationData.totalPages > 1 && (
                <div className="or-pagination">
                  <div className="or-page-info">
                    Showing {orders.length} records · Page {currentPage} of{" "}
                    {paginationData.totalPages}
                  </div>
                  <Pagination className="mb-0" size="sm">
                    <Pagination.Prev
                      disabled={currentPage === 1}
                      onClick={() => handlePageChange(currentPage - 1)}
                    />
                    {renderPaginationItems()}
                    <Pagination.Next
                      disabled={currentPage === paginationData.totalPages}
                      onClick={() => handlePageChange(currentPage + 1)}
                    />
                  </Pagination>
                </div>
              )}
            </>
          )}

          {/* ── Initial empty state ── */}
          {!clicked && (
            <div className="or-empty">
              <div className="or-empty-icon">📊</div>
              <div className="or-empty-title">Select outlet &amp; date range</div>
              <div className="or-empty-sub">
                Select outlet and dates to view the report
                and you can generate report
              </div>
            </div>
          )}
        </div>

        {/* ══════════════════════════════════════════
            FLOATING DOWNLOAD MANAGER PANEL
        ══════════════════════════════════════════ */}
        {dmOpen && (
          <div className="or-dm-panel" ref={dmPanelRef}>

            {/* Header */}
            <div className="or-dm-header">
              <div className="or-dm-header-left">
                <div className="or-dm-header-title">
                  <CloudDownload size={17} /> Download Manager
                </div>
                <div className="or-dm-header-sub">
                  Scheduled Excel export jobs
                </div>

                {/* ── DM Date Filters ── */}
                <div style={{ display: "flex", gap: 10, marginTop: 12, alignItems: "center", flexWrap: "wrap" }}>
                  <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                    <span style={{ fontSize: 9.5, fontWeight: 600, color: "rgba(255,255,255,.55)", textTransform: "uppercase", letterSpacing: ".6px" }}>
                      From
                    </span>
                    <DatePicker
                      selected={dmStartDate}
                      onChange={(date) => handleDmDateChange("start", date)}
                      dateFormat="dd-MM-yyyy"
                      maxDate={new Date()}
                      placeholderText="Start Date"
                      wrapperClassName="dm-date-wrapper"
                      customInput={
                        <input
                          style={{
                            height: 30, padding: "0 10px", borderRadius: 6,
                            border: "1px solid rgba(255,255,255,.2)",
                            background: "rgba(255,255,255,.1)", color: "#fff",
                            fontSize: 12, fontWeight: 500, cursor: "pointer",
                            outline: "none", width: 112,
                          }}
                        />
                      }
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                    <span style={{ fontSize: 9.5, fontWeight: 600, color: "rgba(255,255,255,.55)", textTransform: "uppercase", letterSpacing: ".6px" }}>
                      To
                    </span>
                    <DatePicker
                      selected={dmEndDate}
                      onChange={(date) => handleDmDateChange("end", date)}
                      dateFormat="dd-MM-yyyy"
                      minDate={dmStartDate}
                      maxDate={(() => {
                        if (!dmStartDate) return new Date();
                        const max = new Date(dmStartDate);
                        max.setDate(max.getDate() + 30);
                        const today = new Date();
                        return max > today ? today : max;
                      })()}
                      placeholderText="End Date"
                      customInput={
                        <input
                          style={{
                            height: 30, padding: "0 10px", borderRadius: 6,
                            border: "1px solid rgba(255,255,255,.2)",
                            background: "rgba(255,255,255,.1)", color: "#fff",
                            fontSize: 12, fontWeight: 500, cursor: "pointer",
                            outline: "none", width: 112,
                          }}
                        />
                      }
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                    <span style={{ fontSize: 9.5, color: "transparent" }}>–</span>
                    <button
                      style={{
                        height: 30, padding: "0 12px", borderRadius: 6,
                        border: "1px solid rgba(255,255,255,.25)",
                        background: "rgba(255,255,255,.15)", color: "#fff",
                        fontSize: 11.5, fontWeight: 600, cursor: "pointer",
                        display: "inline-flex", alignItems: "center", gap: 5,
                      }}
                      onClick={() => fetchDownloadStatus(false)}
                      disabled={jobsLoading}
                    >
                      <Search size={11} /> Apply
                    </button>
                  </div>
                  <span style={{ fontSize: 10, color: "rgba(255,255,255,.45)", alignSelf: "flex-end", marginBottom: 3 }}>
                    Max 30-day range
                  </span>
                </div>

                <div className="or-dm-stats">
                  <div className="or-dm-stat">
                    <div className="or-dm-stat-val">{downloadJobs.length}</div>
                    <div className="or-dm-stat-lbl">Total</div>
                  </div>
                  <div className="or-dm-stat">
                    <div className="or-dm-stat-val">{pendingCount}</div>
                    <div className="or-dm-stat-lbl">In Progress</div>
                  </div>
                  <div className="or-dm-stat">
                    <div className="or-dm-stat-val">{completedCount}</div>
                    <div className="or-dm-stat-lbl">Ready</div>
                  </div>
                  <div className="or-dm-stat">
                    <div className="or-dm-stat-val">{failedCount}</div>
                    <div className="or-dm-stat-lbl">Failed</div>
                  </div>
                </div>
              </div>
              <div className="or-dm-header-actions">
                {pollingActive && (
                  <span style={{ fontSize: 11, color: "rgba(255,255,255,.65)", display: "flex", alignItems: "center", gap: 4, marginRight: 4 }}>
                    <span className="or-spin"><ArrowClockwise size={11} /></span> Live
                  </span>
                )}
                <button
                  className="or-dm-icon-btn"
                  onClick={() => {
                    setJobsLoading(true);
                    fetchDownloadStatus().finally(() => setJobsLoading(false));
                  }}
                  title="Refresh"
                  disabled={jobsLoading}
                >
                  {jobsLoading ? (
                    <Spinner size="sm" animation="border" style={{ width: 12, height: 12 }} />
                  ) : (
                    <ArrowClockwise size={13} />
                  )}
                </button>
                <button className="or-dm-icon-btn" onClick={() => setDmOpen(false)} title="Close">
                  <X size={14} />
                </button>
              </div>
            </div>

            {/* Job list */}
            <div className="or-dm-body">
              {downloadJobs.length === 0 ? (
                <div className="or-dm-empty">
                  <CloudDownload size={40} style={{ opacity: 0.2 }} />
                  <div style={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>
                    No download jobs yet
                  </div>
                  <div style={{ fontSize: 12.5, color: "#9ca3af", maxWidth: 280 }}>
                    Select multiple outlets and click <strong>Schedule Download</strong> to queue a job.
                  </div>
                </div>
              ) : (
                downloadJobs.map((job, idx) => {
                  const cls = getJobCls(job.status);
                  const qp = job.queryParams || {};
                  const outlets = job.requestBody?.outletIds || [];
                  return (
                    <div key={job._id || idx} className="or-dm-job">
                      <div className={`or-dm-job-icon ${cls}`}>
                        {getJobIcon(job.status)}
                      </div>
                      <div className="or-dm-job-info">
                        <div className="or-dm-job-name">
                          Order Report — {qp.startDate || "?"} → {qp.endDate || "?"}
                        </div>
                        <div className="or-dm-job-meta">
                          <span style={{ display: "flex", alignItems: "center", gap: 3 }}>
                            <Clock size={10} /> {fmtViewDate(job.createdAt)} {fmtViewTime(job.createdAt)}
                          </span>
                          <span>·</span>
                          <span>{outlets.length} outlet{outlets.length !== 1 ? "s" : ""}</span>
                          {job.errorMessage && (
                            <span style={{ color: "var(--or-danger)" }}>· {job.errorMessage}</span>
                          )}
                        </div>
                        <div className="or-pb-wrap">
                          <div className={`or-pb ${cls}`} />
                        </div>
                      </div>
                      <span className={`or-status-pill ${cls}`}>{getJobLabel(job.status)}</span>
                      {cls === "completed" && job.storagePath && (
                        <button className="or-dl-btn" onClick={() => downloadFile(job)}>
                          <BoxArrowDown size={12} /> Download
                        </button>
                      )}

                      {/* Regenerate button — completed jobs only */}
                      {cls === "completed" && (
                        <button
                          className="or-regen-btn"
                          title="Regenerate this report"
                          disabled={regeneratingJobId === job._id}
                          onClick={() => handleRegenerateReport(job._id)}
                        >
                          {regeneratingJobId === job._id ? (
                            <Spinner animation="border" size="sm" style={{ width: 12, height: 12 }} />
                          ) : (
                            <ArrowClockwise size={14} />
                          )}
                        </button>
                      )}

                      {/* Cancel/Delete button — non-completed & non-failed jobs */}
                      {/* {cls !== "completed" && ( */}
                      <button
                        className="or-del-btn"
                        title="Cancel this request"
                        disabled={deletingJobId === job._id}
                        onClick={() => handleDeleteReportRequest(job._id)}
                      >
                        {deletingJobId === job._id ? (
                          <Spinner animation="border" size="sm" style={{ width: 12, height: 12 }} />
                        ) : (
                          <XCircle size={14} />
                        )}
                      </button>
                      {/* )} */}
                    </div>
                  );
                })
              )}
            </div>

            {/* Footer */}
            <div className="or-dm-footer">
              <span className="or-dm-footer-info">
                {pollingActive ? (
                  <>
                    <span className="or-spin" style={{ display: "inline-flex" }}>
                      <ArrowClockwise size={12} />
                    </span>
                    Auto-refreshing every 5s
                  </>
                ) : (
                  ""
                )}
              </span>
              <button
                style={{
                  height: 30, padding: "0 14px", borderRadius: 6,
                  border: "1.5px solid #e2e6ea", background: "#fff",
                  fontSize: 12, fontWeight: 500, color: "var(--or-muted)", cursor: "pointer",
                  display: "inline-flex", alignItems: "center", gap: 5,
                  opacity: pollingActive ? 0.5 : 1,
                }}
                onClick={startPolling}
                disabled={pollingActive}
              >
                <ArrowClockwise size={11} /> Refresh
              </button>
            </div>
          </div>
        )}

        {/* ══════════════════════════════════════════
            CANCEL ORDER MODAL
        ══════════════════════════════════════════ */}
        <Modal show={openCancelOrderModal} onHide={handleCloseCancelOrderModal} size="lg" centered>
          <Modal.Header closeButton className="or-modal-header">
            <Modal.Title className="or-modal-title">
              <span style={{ color: "#dc2626" }}>⛔</span> Cancel Order
            </Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleCancelOrder}>
            <Modal.Body className="or-modal-body">
              <Row className="mb-3">
                <Col md={4}>
                  <Form.Label className="or-filter-label">
                    Refund Type <span className="text-danger">*</span>
                  </Form.Label>
                  <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}>
                    <Form.Check
                      type="radio" label="Instant Refund" name="refundType" value="INSTANT"
                      checked={refundType === "INSTANT"} onChange={(e) => setRefundType(e.target.value)} id="ref-instant"
                    />
                    <Form.Check
                      type="radio" label="Normal Refund" name="refundType" value="NORMAL"
                      checked={refundType === "NORMAL"} onChange={(e) => setRefundType(e.target.value)} id="ref-normal"
                    />
                  </div>
                </Col>
                <Col md={4}>
                  <Form.Label className="or-filter-label">
                    Stock Management <span className="text-danger">*</span>
                  </Form.Label>
                  <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}>
                    <Form.Check
                      type="radio" label="Restore to inventory" name="stock-refund"
                      checked={isStockRefund === true} onChange={() => setIsStockRefund(true)} id="stock-t"
                    />
                    <Form.Check
                      type="radio" label="Do not restore" name="stock-refund"
                      checked={isStockRefund === false} onChange={() => setIsStockRefund(false)} id="stock-f"
                    />
                  </div>
                </Col>
                <Col md={4}>
                  <Form.Label className="or-filter-label">
                    Approved By <span className="text-danger">*</span>
                  </Form.Label>
                  <Select
                    options={adminUserOptions}
                    value={adminUserOptions.find((o) => o.value === selectedAdminUser)}
                    onChange={(opt) => setSelectedAdminUser(opt?.value || "")}
                    isClearable
                    styles={selectStyles}
                    placeholder="Select approver…"
                  />
                </Col>
              </Row>
              <Form.Group>
                <Form.Label className="or-filter-label">
                  Reason <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea" rows={3} value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Reason for cancellation…" required style={{ fontSize: 13.5 }}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={handleCloseCancelOrderModal} disabled={cancelBtnLoading}>
                Dismiss
              </Button>
              <Button variant="danger" type="submit" disabled={cancelBtnLoading || !reason.trim() || !selectedAdminUser}>
                {cancelBtnLoading ? <Spinner size="sm" animation="border" /> : "Confirm Cancellation"}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        {/* ══════════════════════════════════════════
            VIEW ORDER DETAILS MODAL
        ══════════════════════════════════════════ */}
        <Modal
          show={viewDetailsModal}
          onHide={() => { setViewDetailsModal(false); setSelectedOrder(null); }}
          size="xl"
          centered
        >
          <Modal.Header closeButton className="or-modal-header">
            <Modal.Title className="or-modal-title">Order Details</Modal.Title>
          </Modal.Header>
          <Modal.Body className="or-modal-body">
            {singleOrderDetailsLoading ? (
              <div className="text-center" style={{ padding: "40px 0" }}>
                <Spinner animation="border" variant="primary" />
                <div style={{ marginTop: 12, fontSize: 13.5, color: "#9ca3af" }}>Loading order details…</div>
              </div>
            ) : selectedOrder ? (
              (() => {
                const o = selectedOrder.newOrder;
                console.log("Selected Order for Details Modal:", selectedOrder);
                return (
                  <>
                    {/* Detail grid */}
                    <div className="or-detail-grid">
                      <div className="or-detail-cell">
                        <div className="or-modal-detail-label">Order No</div>
                        <div className="or-modal-detail-val or-orderno">{o.order_sequence}{o.order_no}</div>
                      </div>
                      <div className="or-detail-cell">
                        <div className="or-modal-detail-label">Order Type</div>
                        <div className="or-modal-detail-val">{o.ordersType || "—"}</div>
                      </div>
                      <div className="or-detail-cell">
                        <div className="or-modal-detail-label">Outlet</div>
                        <div className="or-modal-detail-val">{o.outlet?.name || "N/A"}</div>
                      </div>
                      <div className="or-detail-cell">
                        <div className="or-modal-detail-label">Customer</div>

                        {o?.source === "QUICK-ORDER" || o?.source === "QUICK-SERVE" ? (
                          <div
                            className={
                              o?.source === "QUICK-ORDER"
                                ? "text-danger"
                                : "text-success"
                            }
                            style={{ fontWeight: 500, fontSize: 12 }}
                          >
                            {o?.source === "QUICK-ORDER"
                              ? "QR ORDER [Mobile]"
                              : "QUICK SERVE [POS]"}
                          </div>
                          
                        ) : (
                          <>
                            <div className="or-modal-detail-val">
                              {o?.user?.name ||
                                o?.outletUser?.name ||
                                o?.kioskUser?.name ||
                                "N/A"}
                            </div>

                            {getOrderUserBadge(o)}
                          </>
                        )}
                      </div>
                      {/* <div className="or-detail-cell">
                        <div className="or-modal-detail-label">Customer</div>
                        <div className="or-modal-detail-val">
                          {o.user?.name || o.outletUser?.name || o.kioskUser?.name || "N/A"}
                        </div>
                        {getOrderUserBadge(o)}
                      </div> */}
                      <div className="or-detail-cell">
                        <div className="or-modal-detail-label">Mobile</div>
                        <div className="or-modal-detail-val">
                          {
                            o?.source === "QUICK-ORDER" || o?.source === "QUICK-SERVE" ? 
                              o.customerPhoneNumber
                             : 
                            o.user?.mobile || o.outletUser?.mobile || o.kioskUser?.mobile || "N/A"
                          }
                        </div>
                      </div>
                      <div className="or-detail-cell">
                        <div className="or-modal-detail-label">Date &amp; Time</div>
                        <div className="or-modal-detail-val" style={{ fontSize: 12.5 }}>
                          {fmtViewDate(o.createdAt)} · {fmtViewTime(o.createdAt)}
                        </div>
                      </div>
                      <div className="or-detail-cell">
                        <div className="or-modal-detail-label">Status</div>
                        <span className={`or-badge ${getStatusClass(o.orderStatus)}`}>{o.orderStatus}</span>
                      </div>
                      <div className="or-detail-cell">
                        <div className="or-modal-detail-label">Payment</div>
                        <div className="or-modal-detail-val" style={{ fontSize: 12.5 }}>
                          {o.paymentGatewayProvider || o.paymentMode || "N/A"}
                          {o.razorpayOrderId && (
                            <span style={{ color: "#9ca3af", fontSize: 11, display: "block" }}>{o.razorpayOrderId}</span>
                          )}
                        </div>
                      </div>
                      <div className="or-detail-cell">
                        <div className="or-modal-detail-label">Payment Status</div>
                        <Badge bg={o.paymentStatus === "PAID" ? "success" : "danger"}>{o.paymentStatus}</Badge>
                      </div>
                    </div>

                    {/* Coupon info */}
                    {o.coupon && (
                      <div className="or-detail-grid" style={{ gridTemplateColumns: "repeat(3,1fr)", marginBottom: 16 }}>
                        <div className="or-detail-cell">
                          <div className="or-modal-detail-label">Coupon Name</div>
                          <div className="or-modal-detail-val">{o.coupon?.title}</div>
                        </div>
                        <div className="or-detail-cell">
                          <div className="or-modal-detail-label">Coupon Code</div>
                          <div className="or-modal-detail-val" style={{ color: "#dc2626" }}>{o.coupon?.couponCode}</div>
                        </div>
                        <div className="or-detail-cell">
                          <div className="or-modal-detail-label">Usage Type</div>
                          <div className="or-modal-detail-val">{o.coupon?.usageType}</div>
                        </div>
                      </div>
                    )}

                    {/* Items table */}
                    <div style={{ marginBottom: 16 }}>
                      <div className="or-modal-detail-label" style={{ marginBottom: 10 }}>Ordered Items</div>
                      <Table striped bordered hover responsive size="sm" style={{ fontSize: 13 }}>
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th className="text-center">Qty</th>
                            <th className="text-end">Price</th>
                            <th className="text-end">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(selectedOrder.orderItems || []).map((item) => (
                            <tr key={item._id}>
                              <td>
                                {item?.product?.name || "Product"}
                                {item?.addons?.length > 0 && (
                                  <ul className="mb-0" style={{ fontSize: 11.5, color: "#6b7280" }}>
                                    {item.addons.map((a) => (
                                      <li key={a._id}>{a.selectedValue} (₹{a.price})</li>
                                    ))}
                                  </ul>
                                )}
                              </td>
                              <td className="text-center">{item.quantity}</td>
                              <td className="text-end">₹{item.rate?.toFixed(2)}</td>
                              <td className="text-end fw-semibold">₹{getItemTotal(item).toFixed(2)}</td>
                            </tr>
                          ))}
                          {o.platformFees > 0 && (
                            <tr><td colSpan={3} className="text-end">Platform Fees</td><td className="text-end">₹{Number(o.platformFees).toFixed(2)}</td></tr>
                          )}
                          {o.packingCharges > 0 && (
                            <tr><td colSpan={3} className="text-end">Packing Charges</td><td className="text-end">₹{Number(o.packingCharges).toFixed(2)}</td></tr>
                          )}
                          {o.deliveryCharges > 0 && (
                            <tr><td colSpan={3} className="text-end">Delivery Charges</td><td className="text-end">₹{Number(o.deliveryCharges).toFixed(2)}</td></tr>
                          )}
                          {o.totalDiscount > 0 && (
                            <tr><td colSpan={3} className="text-end">Discount</td><td className="text-end text-danger">− ₹{o.totalDiscount?.toFixed(2)}</td></tr>
                          )}
                          {o.totalTaxAmount > 0 && (
                            <tr><td colSpan={3} className="text-end">Tax</td><td className="text-end">+ ₹{o.totalTaxAmount?.toFixed(2)}</td></tr>
                          )}
                          <tr style={{ fontWeight: 700 }}>
                            <td colSpan={3} className="text-end">Grand Total</td>
                            <td className="text-end text-primary">₹{o.grandTotal?.toFixed(2)}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>

                    {/* Status log */}
                    <div>
                      <div className="or-modal-detail-label" style={{ marginBottom: 10 }}>Status Log</div>
                      <Table striped bordered hover responsive size="sm" style={{ fontSize: 13 }}>
                        <thead>
                          <tr>
                            <th>Status</th>
                            <th>Time</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(selectedOrder.orderStatusLogs || []).length > 0 ? (
                            selectedOrder.orderStatusLogs.map((log) => (
                              <tr key={log._id}>
                                <td><Badge bg={getStatusBadgeColor(log.orderStatus)}>{log.orderStatus}</Badge></td>
                                <td>{fmtViewTime(log.createdAt)}</td>
                                <td>{fmtViewDate(log.createdAt)}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={3} className="text-center text-muted">No logs available</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </>
                );
              })()
            ) : (
              <p>No order details available.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="outline-secondary"
              onClick={() => { setViewDetailsModal(false); setSelectedOrder(null); }}
            >
              Close
            </Button>
            {selectedOrder && (
              <Button variant="primary" onClick={() => handlePrintInvoice(selectedOrder)}>
                <Receipt size={14} className="me-1" /> Print Invoice
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default OrdersReport;